import React, { useState, useEffect } from 'react';
import Popup from 'reactjs-popup';
import EcommerceApi from '../../../api/DCecommerceApi';
import DCABSdataApi from '../../../api/DCABSdataApi';
import {
  assign as _assign,
  get as _get,
  forOwn as _forOwn,
  trim,
} from 'lodash-es';
import _ from 'lodash-es';
import HeaderComponent from '../dc-header/HeaderComponent';
import Filters from '../../abs-filter-components/FilterComponents';
import ProductList from '../dc-product-list/ProductList';
import ProductReplace from '../dc-product-list/ProductReplace';
import OutFitComponent from '../outfit-component/OutFitComponent';
import OptionsPopup from '../../dc-utils/OptionsPopup';
import Spinner from '../dc-spinner/Spinner';
// import MRFCData from '../../../api/mrfc_sku_map__rods_lines_reels.json';
import {
  backingProducts,
  categoryMap,
  optionData,
  defaultSorting,
} from '../../utils/Constants';

import {
  sortProductList,
  sortFilterValues,
  sortFilterValuesBuilder,
  sortProductListApplyFilter,
} from '../../utils/HelperMethods';
import { createSharableLinkUrl } from '../../utils/HelperMethods';
import CompatibleWithHelper from '../../utils/CompatibleWithHelper';
import { isCompositeType } from 'graphql';

import CompatioAnalytics from '../../../api/CompatioAnalytics';
let checkprefiltered = _get(window, 'compatioConfig.shopify.prefiltered')
  ? _get(window, 'compatioConfig.shopify.prefiltered')
  : false;

let applyfiltered = _get(window, 'compatioConfig.shopify.applyfiltered')
  ? _get(window, 'compatioConfig.shopify.applyfiltered')
  : false;

window.$.fn.scrollCenter = function(elem, speed) {
  var active = window.$(this).find(elem);
  var activeWidth = active.width() / 1;
  var pos = active.position() && active.position().left + activeWidth;
  var elpos = window.$(this).scrollLeft();
  var elW = window.$(this).width();
  pos = pos + elpos - elW / 2; // for center position if you want adjust then change this
  window.$(this).animate(
    {
      scrollLeft: pos,
    },
    speed == undefined ? 1000 : speed
  );
  return true;
};

const popupStyles = {
  boxShadow: '0 5px 30px rgba(0, 0, 0, 0.4)',
  border: '0px',
  borderLeft: '1px solid',
  padding: 0,
  maxWidth: '100%',
  width: '100%',
  height: 'auto',
  minHeight: '800px',
};

const overlayStyle = {
  background: 'rgba(0, 0, 0, 0.75)',
};

let defaultSelection = {};
optionData.forEach(element => {
  defaultSelection[element.optionId] = element.options[0].value;
});

const DCContainer = ({
  isOpen,
  props,
  modelId,
  bundledProduct,
  setIsOpen,
  setDcDisplay,
  dcConfigDetails,
  preSelectedData,
  preFiltersData,
  preCatOneSection,
  preCatTwoSection,
  OpenPopReels,
  setOpenPopReels,
  noSelectedData,
  setnoSelectedData,
  dataBlankData,
  setdataBlankData,
  selectDataAvailable,
  setSelectDataAvailable,
  setfirstTimeload,
  firstTimeload,
  setNewCat,
  newCat,
  firsAPiStore,
}) => {
  const [collapsedProductDataFilter, setCollapsedProductDataFilter] = useState(
    []
  );

  const [mainProductObject, SetmainProductObject] = useState([]);
  const [Loader, setLoader] = useState(true);

  const [LastFilterSelect, SetLastFilterSelect] = useState([]);
  const [modelSortNameId, SerModelSortNameId] = useState([]);
  const handleChangevariant = (
    variantSku,
    variantPrice,
    variantCompareAtPrice,
    variantTitle
  ) => {
    const IsProductSpecificDC = _get(
      window,
      'compatioConfig.compatibleProducts.isProductSpecificDC'
    )
      ? _get(window, 'compatioConfig.compatibleProducts.isProductSpecificDC')
      : false;
    const IsPlatformShopify =
      typeof _get(window, 'compatioConfig.shopify') === 'object';
    let variantMap = [];
    let storeName = _get(window, 'compatioConfig.shopify.baseUrl');
    // alert(true)
    /*
    variantMap = IsPlatformShopify
      ? MRFCData.find(each => each.store === storeName).skumap
      : [];*/
    // const filterModelId = variantMap.find(e => e.variant_id == variantSku);
    setLoading(true);
    setCollapsedProductData([]);
    setDcDisplay('dc-container-hide');
    const newprod = getOutfitProduct(
      variantSku,
      variantPrice,
      (variantCompareAtPrice = 0),
      variantTitle
    );
    if (IsProductSpecificDC == true) {
      // if (filterModelId != undefined) {
      setOutfitList(newprod);
      setFinalArray([newprod[0].categoryName]);
      fetchData([newprod[0].merchantProductSku], '', {});
      // }
    } else {
      setOutfitList(newprod);
      setFinalArray([newprod[0].categoryName]);
      fetchData([newprod[0].merchantProductSku], '', {});
    }

    // console.log(variantSku,variantPrice,variantCompareAtPrice,variantTitle,'variantSku,variantPrice,variantCompareAtPrice,variantTitle');
    // alert(6);
  };
  window.compatioConfig.compatibleProducts.methods.handleChangevariant = handleChangevariant;
  const getCurrentName = (categoryName, currentOutfit) => {
    let categoryCheck = currentOutfit.find(
      eachCat => eachCat.categoryName == categoryName
    );
    if (categoryCheck != undefined) {
      return '';
    } else {
      return categoryName;
    }
  };
  const getCategoryName = productType => {
    let categoryName;

    if (OpenPopReels == false) {
      categoryName = categoryMap.find(each =>
        each.shopifyValues.includes(productType)
      );
    } else {
      categoryName = categoryMap.find(each =>
        each.shopifyValues.includes('Reels')
      );
      // setOpenPopReels(false)
    }
    if (categoryName) return categoryName.compatioCategory;

    // console.log(categoryName,'categoryName')
    return productType;
  };
  const [masterFilterOptions, SetMasterFilterOptions] = useState([]);
  const [inputData, setInputData] = useState();
  const [stopRunShareFun, setStopRunShareFun] = useState(false);
  const [isFull, SetIsFull] = useState(false);

  const afterClearBuilderCallAgain = () => {
    if (props.productSku != undefined) {
      fetchData([props.productSku], '', '');
    } else {
      fetchData([], '', '');
    }
    SetIsFull(false);
  };
  const getCurrentFilter = (filter, currentOutfit) => {
    let categoryCheck = currentOutfit.find(
      eachCat => eachCat.categoryName == filter.categoryName
    );
    if (categoryCheck != undefined) {
      return [];
    } else {
      return filter.filterData;
    }
  };
  const getOutfitProduct = (
    variantSku,
    variantPrice,
    variantCompareAtPrice,
    variantTitle,
    parentProductId,
    bundledProduct
  ) => {
    let outfit = [];
    if (props.productSku === undefined) {
      return [];
    } else {
      // console.log(props, 'props');
      // console.log(props.productType ? getCategoryName(props.productType) : props.productType,'props.productType ? getCategoryName(props.productType) : props.productType')
      outfit.push({
        categoryName: props.productType
          ? getCategoryName(props.productType)
          : props.productType,
        categoryCurrent: props.productType
          ? getCategoryName(props.productType)
          : props.productType,
        merchantProductSku: variantSku ? variantSku : '',
        parentProductId: parentProductId,
        price: variantPrice ? variantPrice : '',
        compareAtPrice: variantCompareAtPrice,
        productName: props.productName ? props.productName : '',
        url_image: props.productImage ? props.productImage : '',
        url_product: '',
        variantName: props.productName
          ? `${props.productName}-${variantTitle}`
          : '',
        variantTitle: variantTitle ? variantTitle : '',
        isSourceProduct: true,
      });
      if (bundledProduct != undefined) {
        outfit.push({
          categoryName: bundledProduct.categoryName,
          categoryCurrent: bundledProduct.categoryName,
          merchantProductSku: bundledProduct.merchantProductSku,
          price: bundledProduct.price,
          productName: bundledProduct.productName,
          url_image: bundledProduct.url_image,
          url_product: '',
          variantName: bundledProduct.variantName,
          variantTitle: bundledProduct.variantTitle,
        });
      }
      return outfit;
    }
  };
  const currentOutfit =
    preSelectedData && preSelectedData.length > 0
      ? preSelectedData
      : props.productSku === undefined
      ? []
      : getOutfitProduct(
          props.productSku,
          props.price,
          props.compareAtPrice,
          props.variantTitle,
          props.parentProductId,
          bundledProduct
        );
  // console.log(props,'currentOutfitcurrentOutfit')
  const optionsObject =
    getCategoryName(props.productType) === 'Reels' ||
    (getCategoryName(props.productType) === 'Fly Reel' &&
      backingProducts.length > 0)
      ? {
          show: true,
          details: defaultSelection,
          backingProduct:
            backingProducts.length > 0 ? backingProducts[0].variantId : null,
        }
      : { show: false };

  const [sortedProducts, setsortedProducts] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [rootMainProductObject, setRootMainProductObject] = useState([]);
  const [CloneForFliter, setCloneForFliter] = useState([]);
  const [configData, setConfigData] = useState([]);
  const [afterClearOutFit, setAfterClearOutFit] = useState(false);

  const [masterProData, setmasterProData] = useState([]);
  const [masterProFilterData, setmasterProFilterData] = useState([]);
  const [
    afterClearOutFitProductPage,
    setAfterClearOutFitProductPage,
  ] = useState(false);
  // console.log(props.productType,'bundledProduct')
  // const [ShowOptions, setShowOptions] = useState(
  //   (
  //     getCategoryName(props.productType) === 'Reels' ||
  //     getCategoryName(props.productType) === 'Fly Reel' && backingProducts.length > 0
  //   ) &&
  //   (
  //     bundledProduct &&
  //     getCategoryName(bundledProduct.categoryName) === 'Reels' ||
  //     getCategoryName(bundledProduct.categoryName) === 'Fly Reel'
  //   )
  // );

  // const [ShowOptions, setShowOptions] = useState(
  //   getCategoryName(props.productType) === 'Reels' ||
  //     (getCategoryName(props.productType) === 'Fly Reel' &&
  //       backingProducts.length > 0) ||
  //     (bundledProduct &&
  //       getCategoryName(bundledProduct.categoryName) === 'Reels')
  // );
  // console.log(preSelectedData,'preSelectedData')
  const [ShowOptions, setShowOptions] = useState(
    preSelectedData && preSelectedData.length == 0
      ? getCategoryName(props.productType) === 'Reels' ||
          (getCategoryName(props.productType) === 'Fly Reel' &&
            backingProducts.length > 0) ||
          (bundledProduct &&
            getCategoryName(bundledProduct.categoryName) === 'Reels')
      : false
  );

  const [optionsDetails, setOptionsDetails] = useState(optionsObject);
  const [currentCategory, setCurrentCategory] = useState(
    currentOutfit.length === 0
      ? props.productType
      : preFiltersData && preFiltersData.length > 0
      ? getCurrentName(
          preFiltersData[preFiltersData.length - 1].categoryName,
          currentOutfit
        )
      : // ? preFiltersData[preFiltersData.length - 1].categoryName
        ''
  );
  const [collapsedProductData, setCollapsedProductData] = useState([]);

  const [dse, setDse] = useState([]);
  const [checkCatFil, setCheckCatFil] = useState(false);
  const [notcatmatch, setnotcatmatch] = useState(false);
  const [proAdded, setproAdded] = useState(false);
  const [reApply, setReApply] = useState([]);
  const [rem, setRem] = useState([]);
  const [removeFil, setRemoveFil] = useState([]);
  const [obj, setObj] = useState([]);
  const [currentSlelctedCat, setCurrentSlelctedCat] = useState([]);

  const [masterVariantList, setMasterVariantList] = useState([]);
  const [isReplaceTrue, setIsReplaceTrue] = useState(false);
  const [itemToReplace, setItemToReplace] = useState({});
  const [finalArray, setFinalArray] = useState(
    props.productSku && props.productType
      ? [
          getCategoryName(props.productType),
          //bundledProduct && getCategoryName(bundledProduct.categoryName),
        ]
      : ['Reels']
  );
  const [outfitList, setOutfitList] = useState(currentOutfit);
  // console.log(outfitList,currentOutfit,'currentOutfit 2')
  const [sortOrder, setSortOrder] = useState(
    currentOutfit.length === 0 && defaultSorting
      ? defaultSorting
      : 'compatioscore_descending'
  );
  // const [sortOrder, setSortOrder] = useState(
  //   currentOutfit.length === 0 && defaultSorting
  //     ? 'compatioscore_descending'
  //     : 'compatioscore_descending'
  // );
  const [appliedFilters, setAppliedFilters] = useState(
    preFiltersData && preFiltersData.length > 0
      ? getCurrentFilter(
          preFiltersData[preFiltersData.length - 1],
          currentOutfit
        )
      : []
  );

  const [deselectFilter, setdeselectFilter] = useState([]);

  const [filtersAppliedone, setFiltersAppliedone] = useState([]);
  const [filtersAppliedoneTrue, setFiltersAppliedoneTrue] = useState(false);
  const [currentFilterData, setCurrentFilterData] = useState([]);
  const [applySelectedFilters, setApplySelectedFilters] = useState(false);
  const [afterApplyFilter, setAfterApplyFilter] = useState([]);
  const [afterApplyFilterNeu, setAfterApplyFilterNeu] = useState([]);

  const [applyFilterWise, setApplyFilterWise] = useState('no filter');
  const [categoryWiseFilters, setCategoryWiseFilters] = useState(
    preFiltersData && preFiltersData.length > 0 ? preFiltersData : []
  );

  const [OtherCatData, setOtherCatData] = useState([]);
  //methods
  const fetchEcommerceData = async (categoryDetails, CategoryID) => {
    let selectedProductData = [],
      notselectedProductData = [];
    const selectedMerchantProductSkus = DCABSdataApi.extractProductSkusByCategoryId(
      categoryDetails,
      CategoryID
    );
    // console.log(
    //   categoryDetails,
    //   CategoryID,
    //   'CategoryIDCategoryID',
    //   selectedMerchantProductSkus,
    //   notselectedMerchantProductSkus
    // );
    // console.log(CategoryID,'selectedProductData',categoryDetails,selectedMerchantProductSkus  )

    if (selectedMerchantProductSkus && selectedMerchantProductSkus.length) {
      selectedProductData = await EcommerceApi.loadProductDataFromEcommerce(
        selectedMerchantProductSkus,
        'shopify',
        categoryDetails,
        CategoryID
      );
      return selectedProductData.data;
    }
  };

  const fetchEcommerceDataCatWise = async (categoryDetails, CategoryID) => {
    let selectedProductData = [];
    const selectedMerchantProductSkus = DCABSdataApi.extractProductSkusByCategoryId(
      categoryDetails,
      CategoryID
    );

    // console.log(
    //   selectedMerchantProductSkus,
    //   'selectedMerchantProductSkus',
    //   categoryDetails,
    //   CategoryID
    // );
    if (selectedMerchantProductSkus && selectedMerchantProductSkus.length) {
      selectedProductData = await EcommerceApi.loadProductDataFromEcommerce(
        selectedMerchantProductSkus,
        'shopify',
        categoryDetails,
        CategoryID
      );
      return selectedProductData.data;
    } else {
    }
  };

  const handleChangeSortOrder = sortOrders => {
    let currentAnalyticCat = [
      ...configData.default_categories,
      ...configData.possible_categories,
    ].filter(e => e.display_name == currentCategory);

    // console.log(props, 'propsprops', sortOrder, modelSortNameId);
    CompatioAnalytics.track(
      CompatioAnalytics.events.xrsSortByChange,
      {
        baseFinalProductID: props.productSku,
        baseParentProductID: props.productSku,
        baseFinalProductName: props.productName,
        categoryID: currentAnalyticCat[0].unique_name,
        categoryName: currentAnalyticCat[0].display_name,
        categoryPosition: +currentAnalyticCat[0].unique_name.split('__')[0],
        oldSortOrder: sortOrder,
        newSortOrder: sortOrders,
      },
      'SmartBuilder',
      'V2',
      props.modelID ? props.modelID : modelSortNameId[0],
      props.modelShortName ? props.modelShortName : modelSortNameId[1]
    );
    setSortOrder(sortOrders);
  };

  const handleRemoveItem = async itemToRemove => {
    // setLoading(true);
    // alert(2);
    // console.log(itemToRemove, 'itemToRemove');
    if (itemToRemove.merchantProductSku === optionsDetails.backingProduct) {
      optionsDetails.details.backing_option = 'No Backing';
      setOptionsDetails(optionsDetails);
    }
    let newListNeu = outfitList.filter(item => {
      return item.categoryName !== 'Backing';
    });
    // console.log(newListNeu,'newListNeu',categoryMap)
    if (itemToRemove.categoryName != 'Backing') {
      SetIsFull(false);
      setIsReplaceTrue(false);
    }
    let newList = outfitList.filter(item => {
      return item.merchantProductSku !== itemToRemove.merchantProductSku;
    });
    if (newList.length == 0) {
      // console.log('1',categoryChckForCallData.filter(
      //   e => e.display_name == itemToRemove.categoryCurrent
      // )[0].display_name);
      if (itemToRemove.categoryCurrent != undefined) {
        setCurrentCategory(
          categoryChckForCallData.filter(
            e => e.display_name == itemToRemove.categoryCurrent
          )[0].display_name
        );
        setOutfitList([]);
        setFinalArray([]);
        // console.log(categoryChckForCallData, itemToRemove,'itemToRemove true',isReplaceTrue)
        await fetchDataCategorywise(
          [],
          categoryChckForCallData.filter(
            e => e.display_name == itemToRemove.categoryCurrent
          )[0].unique_name,
          appliedFilters
        );
      } else {
        //itemToRemove.categoryName
        setCurrentCategory(
          categoryChckForCallData.filter(
            e => e.unique_name == itemToRemove.categoryName
          )[0].display_name
        );
        setOutfitList([]);
        setFinalArray([]);
        // console.log(categoryChckForCallData.filter(e=>e.unique_name==itemToRemove.categoryName),'fasdf',categoryChckForCallData,itemToRemove.categoryName)
        await fetchDataCategorywise(
          [],
          categoryChckForCallData.filter(
            e => e.unique_name == itemToRemove.categoryName
          )[0].unique_name,
          appliedFilters
        );
      }
      // console.log(categoryChckForCallData.filter(e=>e.display_name==itemToRemove.categoryCurrent),itemToRemove.categoryCurrent)
    } else {
      // console.log('3');
      // console.log(itemToRemove, 'newList');
      if (newList.length === 0 && defaultSorting !== undefined)
        handleChangeSortOrder(defaultSorting);
      if (
        itemToRemove.categoryName
          ? itemToRemove.categoryName.split('__')[2] === 'Reels' ||
            itemToRemove.categoryName.split('__')[2] === 'Fly Reel'
          : itemToRemove.categoryCurrent === 'Reels' ||
            itemToRemove.categoryCurrent === 'Fly Reel'
      )
        newList = newList.filter(item =>
          item.categoryName
            ? item.categoryName != 'Backing'
            : item.categoryCurrent != 'Backing'
        );
      // console.log(itemToRemove,'itemToRemove.categoryName')

      const newFinalList = finalArray.filter(cat => {
        if (itemToRemove.categoryName == undefined) {
          return cat && cat !== itemToRemove.categoryCurrent
            ? itemToRemove.categoryCurrent
            : itemToRemove.categoryCurrent &&
                !cat.includes(
                  itemToRemove.categoryCurrent
                    ? itemToRemove.categoryCurrent
                    : itemToRemove.categoryCurrent
                );
        } else {
          return cat && cat !== itemToRemove.categoryName.split('__')[2]
            ? itemToRemove.categoryName.split('__')[2]
            : itemToRemove.categoryCurrent &&
                !cat.includes(
                  itemToRemove.categoryName.split('__')[2]
                    ? itemToRemove.categoryName.split('__')[2]
                    : itemToRemove.categoryCurrent
                );
        }
      });

      // console.log(newFinalList, 'newFinalList', itemToRemove, finalArray);

      const findStoreCategory = categoryWiseFilters.find(each =>
        each.categoryName === itemToRemove.categoryName
          ? itemToRemove.categoryName.split('__')[2]
          : itemToRemove.categoryCurrent
      );
      if (itemToRemove.categoryName != 'Backing') {
        setFinalArray(newFinalList);
      }
      setOutfitList(newList);
      // console.log(itemToRemove.categoryName.split('__')[2],newList,newFinalList,'newListnewList',categoryWiseFilters,finalArray)
      // setAppliedFilters([]);

      if (findStoreCategory !== undefined) {
        setAppliedFilters(findStoreCategory.filterData);
        setAfterApplyFilter(findStoreCategory.filterData);
        setAfterApplyFilterNeu(findStoreCategory.filterData);
        setApplySelectedFilters(true);
        // alert();
      } else {
        setAppliedFilters([]);
        setAfterApplyFilter([]);
        setAfterApplyFilterNeu([]);
        setApplySelectedFilters(false);
      }
      setIsReplaceTrue(false);

      // console.log('remove data', itemToRemove);
      if (itemToRemove.categoryName != 'Backing') {
        const variantList = newList.map(outfit => outfit.merchantProductSku);

        // console.log(
        //   newFinalList,
        //   'newFinalList',
        //   newList,
        //   finalArray,
        //   itemToRemove,
        //   'variantList',
        //   variantList,
        //   newList
        // );
        setLoading(true);
        if (itemToRemove.categoryName != undefined) {
          if (newList.length === 0) {
            // alert(0);
            setCurrentCategory(
              categoryChckForCallData.filter(
                e => e.display_name == itemToRemove.categoryName.split('__')[2]
              )[0].display_name
            );
            await fetchDataCategorywise(
              variantList,
              categoryChckForCallData.filter(
                e => e.display_name == itemToRemove.categoryName.split('__')[2]
              )[0].unique_name,
              appliedFilters
            );
          } else {
            // alert(1);
            setCurrentCategory(itemToRemove.categoryName);
            await fetchData(
              variantList,
              itemToRemove.categoryName != undefined
                ? itemToRemove.categoryName.split('__')[2]
                : itemToRemove.categoryCurrent,
              appliedFilters
            );
          }
        } else {
          // await fetchData(
          //   variantList,
          //   categoryChckForCallData.filter(
          //     e => e.display_name == itemToRemove.categoryCurrent
          //   )[0].unique_name,
          //   appliedFilters
          // );
          if (newList.length === 0) {
            setCurrentCategory(
              categoryChckForCallData.filter(
                e => e.display_name == itemToRemove.categoryCurrent
              )[0].display_name
            );
            await fetchDataCategorywise(
              variantList,
              categoryChckForCallData.filter(
                e => e.display_name == itemToRemove.categoryCurrent
              )[0].unique_name,
              appliedFilters
            );
          } else {
            setCurrentCategory(itemToRemove.categoryName);
            await fetchData(
              variantList,
              itemToRemove.categoryName != undefined
                ? itemToRemove.categoryName.split('__')[2]
                : itemToRemove.categoryCurrent,
              appliedFilters
            );
          }
        }
        //  console.log(variantList, itemToRemove.categoryName, appliedFilters,'variantList, itemToRemove.categoryName, appliedFilters');
      }
    }
    // category animation script starts here
    window.$('.pagescroll').removeClass('active');
    window.$('#pagescrollactive').addClass('active');
    setTimeout(function() {
      window.$('#dc-header-head').scrollCenter('.active', 300);
    }, 1000);
  };

  const [categorywiseData, setcategorywiseData] = useState([]);
  const [categorywiseDataTrue, setcategorywiseDataTrue] = useState(false);

  const [categoryChckForCallData, setcategoryChckForCallData] = useState([]);
  const handleCategoryChange = async category => {
    // console.log(rootMainProductObject,CloneForFliter,'collapsedProductData')
    setLoading(true);
    const selectedCats = outfitList.map(each => {
      if (each.categoryCurrent != undefined) return each.categoryCurrent;
      else return each.categoryName.split('__')[2];
    });
    // alert(category)
    setcategorywiseDataTrue(true);
    // const CloneForFilterProductSet = _.cloneDeep(collapsedProductData);
    setcategorywiseData(collapsedProductData);

    const alreadyAdded = selectedCats.includes(category);
    // alert(alreadyAdded)
    // console.log(alreadyAdded,'alreadyAdded',outfitList,selectedCats)
    // console.log(category,alreadyAdded,'alreadyAdded',selectedCats,collapsedProductData.map(e=>e.categoryData)[0])
    if (alreadyAdded) {
      const itemToRemove = outfitList.find(each => {
        if (
          each.categoryCurrent != undefined &&
          each.categoryCurrent == category
        )
          return each;
        else if (
          each.categoryName != undefined &&
          each.categoryName.split('__')[2] == category
        )
          return each;
      });
      // console.log(itemToRemove,'itemToRemove')
      setIsReplaceTrue(true);
      setItemToReplace({
        product: itemToRemove.parentProductId,
        variants: [itemToRemove],
      });
      setCurrentCategory(category);
    } else {
      if (outfitList.length == 0) {
        // console.log(
        //   categoryChckForCallData.filter(e => e.display_name == category)[0]
        //     .unique_name
        // );

        fetchDataCategorywise(
          [],
          categoryChckForCallData.filter(e => e.display_name == category)[0]
            .unique_name,
          appliedFilters
        );
        setIsReplaceTrue(false);
        let filterCatPro = CloneForFliter.filter(ee => {
          if (
            ee.variants.map(esv => esv.categoryName.split('__'))[0][2] ==
            category
          ) {
            return ee;
          }
        });

        // CreateFilteredNew(filterCatPro);
        setCurrentCategory(category);
        // setCollapsedProductData([]);
        setCollapsedProductDataFilter([]);
      } else {
        setIsReplaceTrue(false);
        let filterCatPro = rootMainProductObject.filter(ee => {
          if (
            ee.variants.map(esv => esv.categoryName.split('__'))[0][2] ==
            category
          ) {
            return ee;
          }
        });

        setLoading(true);

        CreateFilteredNew(filterCatPro);
        setCurrentCategory(category);
        setCollapsedProductData([
          {
            categoryName: category,
            categoryData: filterCatPro,
          },
        ]);

        setCollapsedProductDataFilter([
          {
            categoryName: category,
            categoryData: filterCatPro,
          },
        ]);

        // console.log(
        //   filterCatPro,
        //   collapsedProductData,
        //   collapsedProductDataFilter,
        //   'CloneForFliter',
        //   category,
        //   [
        //     {
        //       categoryName: category,
        //       categoryData: filterCatPro,
        //     },
        //   ]
        // );

        let variantCount = [];
        filterCatPro.map(et => et.variants.map(ets => variantCount.push(ets)));

        // console.log(filterCatPro,variantCount,'filterCatPro')
        setMasterVariantList(
          variantCount.filter(
            (arr, index, self) =>
              index ===
              self.findIndex(
                t => t.merchantProductSku === arr.merchantProductSku
              )
          )
        );
      }
    }
    setAppliedFilters([]);
  };

  const CreateFilteredNew = tempDataCollection => {
    // console.log(tempDataCollection,'category1')
    // tempDataCollection.forEach(element => {
    //   element.variants.forEach(eleVar=>{
    //     eleVar.abs_string.forEach(eleAbsVar=>{
    //       if( eleAbsVar.meta != `[object Object]`)
    //       eleAbsVar.meta = JSON.parse(eleAbsVar.meta)
    //     })
    //   })
    // })
    // console.log(tempDataCollection, 'gs');
    const CloneForFilterProductSet = _.cloneDeep(tempDataCollection);
    let filterNamesBuilders = [];
    CloneForFilterProductSet.forEach(eachProduct => {
      eachProduct.variants.forEach(eachProductVariants => {
        let groupBuilderFilter = _.groupBy(
          eachProductVariants.abs_string,
          'attr'
        );
        // console.log(groupBuilderFilter,'groupBuilderFiltergroupBuilderFilter')
        _forOwn(groupBuilderFilter, (filterType, key) => {
          filterType.forEach(each => {
            let index = filterNamesBuilders.findIndex(
              each => each.attr === key
            );
            // console.log(filterNamesBuilder,'filterNamesBuilder',index)
            if (index === -1) {
              filterNamesBuilders.push({
                attr: key,
                name: each.meta.displayName,
                values: each.vals,
                valuesPerRow: each.meta.valuesPerRow,
                rank: each.rank,
              });
            } else {
              let newValues = filterNamesBuilders[index].values;
              each.vals.forEach(val => {
                if (
                  newValues.findIndex(each => each.value === val.value) === -1
                )
                  newValues.push(val);
              });
              filterNamesBuilders[index].values = newValues;
            }
          });
        });
      });
    });
    const sortedFiltersForBuilders = sortFilterValues(filterNamesBuilders);
    // below line add after raising issue by sajeevan :- as per him in reds filters not showing filters in proper rank wise.
    sortedFiltersForBuilders.sort(function(a, b) {
      return parseFloat(a.rank) - parseFloat(b.rank);
    });
    // console.log(sortedFiltersForBuilders,'sortedFiltersForBuilder')

    setCurrentFilterData(sortedFiltersForBuilders);

    SetMasterFilterOptions(sortedFiltersForBuilders);
    // setCurrentFilterData(sortedFiltersForBuilder);

    setmasterProFilterData(sortedFiltersForBuilders);
  };
  const [categoyrListPreSets, SetCategoryListPreSets] = useState([]);
  const [optionalListPreSets, SetOptionalListPreSets] = useState([]);
  const getCollapsedProductData = (productDetails, categoryName) => {
    const CollapsedProducts = [];
    // previously working code for collapsing - this created issue for daves - so commented
    let group = _.groupBy(productDetails, 'parentProductId');
    _forOwn(group, (collapsedVariants, key) => {
      // console.log(collapsedVariants[0].groupset,'group')
      CollapsedProducts.push({
        product: key,
        variants: collapsedVariants,
        groupset: collapsedVariants[0].categoryName,
        categoryName: collapsedVariants[0].categoryName,
      });
    });

    // below logic added to fix sorting in daves - This logic is our custom code to collapse
    // console.log(productDetails,categoryName,'cat produ',configData)
    // console.log(group,'productDetails',productDetails)
    productDetails.forEach(element => {
      element.abs_string = element.abs_string;
      if (element.abs_string != null) {
        element.abs_string.forEach(elementAbs => {
          elementAbs.meta = elementAbs.meta;
        });
      }
      let ifExists = CollapsedProducts.find(
        each => each.product === element.parentProductId
      );
      if (ifExists === undefined)
        CollapsedProducts.push({
          product: element.parentProductId,
          categoryName: element.categoryName,
          groupset: element.categoryName,
          variants: [element],
        });
      else {
        ifExists.variants.push(element);
      }
    });
    // here adding abs_string in shopify variant respnse
    // console.log(productDetails,'newsortedProducts')

    const CloneForFilterProductSet = _.cloneDeep(CollapsedProducts);
    // SetmainProductObject(CloneForFilterProductSet);
    setCloneForFliter([...CollapsedProducts]);
    setRootMainProductObject([...CollapsedProducts]);
    // console.log(categoryName,CollapsedProducts,'setCollapsedProductData',CloneForFilterProductSet)
    // alert(1)
    // console.log(
    //   CollapsedProducts.filter(e => e.groupset.split('__')[2] === categoryName),
    //   'optionalListPreSets',
    //   categoryName
    // );
    // gauravVasisht
    // get filter request getCollapsedProductData line number 1108
    CreateFilteredNew(
      CollapsedProducts.filter(
        e => e.categoryName.split('__')[2] === categoryName
      )
    );
    setCollapsedProductData([
      {
        categoryName: categoryName,
        categoryData: CollapsedProducts.filter(
          e => e.categoryName.split('__')[2] === categoryName
        ),
      },
    ]);
    setCollapsedProductDataFilter([
      {
        categoryName: categoryName,
        categoryData: CollapsedProducts.filter(
          e => e.categoryName.split('__')[2] === categoryName
        ),
      },
    ]);

    SetmainProductObject([
      {
        categoryName: categoryName,
        categoryData: CollapsedProducts.filter(
          e => e.categoryName.split('__')[2] === categoryName
        ),
      },
    ]);

    setmasterProData([
      {
        categoryName: categoryName,
        categoryData: CollapsedProducts.filter(
          e => e.categoryName.split('__')[2] === categoryName
        ),
      },
    ]);

    let variantCount = [];
    CollapsedProducts.filter(
      e => e.categoryName.split('__')[2] === categoryName
    ).map(et => et.variants.map(ets => variantCount.push(ets)));
    setMasterVariantList(
      variantCount
        .filter(e => e.categoryName.split('__')[2] === categoryName)
        .filter(
          (arr, index, self) =>
            index ===
            self.findIndex(t => t.merchantProductSku === arr.merchantProductSku)
        )
    );
  };

  const getCollapsedProductDataAfterSorting = (
    productDetails,
    categoryName
  ) => {
    const CollapsedProducts = [];
    // previously working code for collapsing - this created issue for daves - so commented
    let group = _.groupBy(productDetails, 'parentProductId');
    _forOwn(group, (collapsedVariants, key) => {
      // console.log(collapsedVariants[0].groupset,'group')
      CollapsedProducts.push({
        product: key,
        variants: collapsedVariants,
        groupset: collapsedVariants[0].categoryName,
        categoryName: collapsedVariants[0].categoryName,
      });
    });

    productDetails.forEach(element => {
      element.abs_string = element.abs_string;
      if (element.abs_string != null) {
        element.abs_string.forEach(elementAbs => {
          elementAbs.meta = elementAbs.meta;
        });
      }
      let ifExists = CollapsedProducts.find(
        each => each.product === element.parentProductId
      );
      if (ifExists === undefined)
        CollapsedProducts.push({
          product: element.parentProductId,
          categoryName: element.categoryName,
          groupset: element.categoryName,
          variants: [element],
        });
      else {
        ifExists.variants.push(element);
      }
    });

    const CloneForFilterProductSet = _.cloneDeep(CollapsedProducts);
    setCloneForFliter([...CollapsedProducts]);
    setCollapsedProductData([
      {
        categoryName: categoryName,
        categoryData: CollapsedProducts.filter(
          e => e.categoryName.split('__')[2] === categoryName
        ),
      },
    ]);
  };

  const getCollapsedProductDataforCat = (productDetails, categoryName) => {
    // console.log(productDetails, 'productDetailsproductDetails');
    const CollapsedProducts = [];
    // previously working code for collapsing - this created issue for daves - so commented
    let group = _.groupBy(productDetails, 'parentProductId');
    _forOwn(group, (collapsedVariants, key) => {
      // console.log(collapsedVariants[0].groupset,'group')
      CollapsedProducts.push({
        product: key,
        variants: collapsedVariants,
        groupset: collapsedVariants[0].categoryName,
        categoryName: collapsedVariants[0].categoryName,
      });
    });

    // below logic added to fix sorting in daves - This logic is our custom code to collapse
    // console.log(productDetails,categoryName,'cat produ',configData)
    // console.log(group, 'productDetailsGet', productDetails);
    productDetails.forEach(element => {
      element.abs_string = JSON.parse(element.abs_string);
      if (element.abs_string != null) {
        element.abs_string.forEach(elementAbs => {
          elementAbs.meta = JSON.parse(elementAbs.meta);
        });
      }
      let ifExists = CollapsedProducts.find(
        each => each.product === element.parentProductId
      );
      if (ifExists === undefined)
        CollapsedProducts.push({
          product: element.parentProductId,
          categoryName: element.categoryName,
          groupset: element.categoryName,
          variants: [element],
        });
      else {
        ifExists.variants.push(element);
      }
    });
    // here adding abs_string in shopify variant respnse
    // console.log(
    //   CollapsedProducts,
    //   categoryName,
    //   'CollapsedProductsCollapsedProducts'
    // );

    setCloneForFliter([...CollapsedProducts]);
    // console.log(categoryName,CollapsedProducts,'setCollapsedProductData',CloneForFilterProductSet)
    // alert(1)
    // console.log(CollapsedProducts.filter(e=>e.groupset.split('__')[2] === categoryName),'optionalListPreSets',categoryName)

    setCollapsedProductData([
      {
        categoryName: categoryName.split('__')[2],
        categoryData: CollapsedProducts.filter(
          e => e.categoryName === categoryName
        ),
      },
    ]);
    setCollapsedProductDataFilter([
      {
        categoryName: categoryName.split('__')[2],
        categoryData: CollapsedProducts.filter(
          e => e.categoryName === categoryName
        ),
      },
    ]);
  };

  const toggleBundler = () => {
    setShowOptions(!ShowOptions);
  };

  const handleAdd = backingProduct => {
    setOutfitList(oldOutfitlist => [...oldOutfitlist, backingProduct]);
    toggleBundler();
  };

  const fetchData = async (
    outfitProducts,
    categoryLookingAt,
    filteroptions
  ) => {
    // alert(categoryLookingAt)
    // console.log(categoryLookingAt.categoryName,'categoryLookingAt')
    const compatioCategoryData = await DCABSdataApi.getCategoryDataByProductSku(
      outfitProducts,
      categoryLookingAt,
      filteroptions,
      modelId
    );

    SerModelSortNameId([
      compatioCategoryData.input.builder_model,
      compatioCategoryData.meta.builder.model.builder_short_name,
    ]);
    let newsortedProducts = [];
    let configData = [];
    const InitialData = compatioCategoryData;
    if (
      InitialData !== undefined &&
      Object.entries(InitialData.results).length != 0
    ) {
      const productDataResult = [];
      const lascurrectcat = [];
      for (const [key, value] of Object.entries(InitialData.results)) {
        // console.log(key,value,'prodductDataResult');
        value.forEach(element => {
          element = {
            abs_string: JSON.parse(element.abs_string),
            image: element.image,
            name: element.name,
            parent_product_id: element.parent_product_id,
            product: element.product,
            variant_id: element.variant_id,
            groupset: key,
            categoryName: key,
          };
          if (element.abs_string != null) {
            element.abs_string.forEach(ae => {
              ae.meta = JSON.parse(ae.meta);
            });
          }
          // console.log(element,'element')
          // console.log(element.abs_string.map(ae=>JSON.parse(ae.meta)),'element')
          productDataResult.push(element);
        });

        lascurrectcat.push(key);
      }

      lascurrectcat.sort(function(a, b) {
        return a.split('__')[0].localeCompare(b);
      });

      if (!categoryLookingAt) {
        // alert(lascurrectcat[lascurrectcat.length-1].split('__')[2]+'+'+categoryLookingAt)
        setCurrentCategory(lascurrectcat[0].split('__')[2]);
      } else {
        // alert(lascurrectcat[lascurrectcat.length-1].split('__')[2]+'-'+categoryLookingAt)
        setCurrentCategory(categoryLookingAt);
      }
      let catonesec = InitialData.meta.builder.component_types.REQUIRED.map(
        each => each.display_name
      );

      let cattwosect = [];
      if (InitialData.meta.builder.component_types.OPTIONAL != undefined) {
        cattwosect = InitialData.meta.builder.component_types.OPTIONAL.map(
          each => each.display_name
        );
      } else {
        cattwosect = [];
      }
      // console.log(catonesec,'cattwosectforBuilder')
      // console.log("fasdf",cattwosect)
      SetCategoryListPreSets(catonesec);
      SetOptionalListPreSets(cattwosect);
      // console.log(catonesec,cattwosect,'SetOptionalListPreSetsSetOptionalListPreSets')
      configData = Object.assign(InitialData.meta.builder.component_types, {
        categoriesLeft: InitialData.meta.builder.component_types.REQUIRED,
        default_categories: InitialData.meta.builder.component_types.REQUIRED,
        possible_categories: InitialData.meta.builder.component_types.OPTIONAL,
        input: InitialData.meta.builder.model,
      });

      // console.log(configData,'configData')
      setConfigData(configData);
      // setCurrentFilterData(InitialData.attributes);
      setCurrentFilterData([]);
      // alert(InitialData.categoryLookingAt)
      //Object.keys(InitialData.meta.selection_details)[0].split('__')[2]

      // console.log(productDataResult.filter(e=>e.groupset == lascurrectcat[lascurrectcat.length-1]),'prodductDataResult',lascurrectcat[lascurrectcat.length-1])
      let tempDataCollection;
      // console.log(
      //   lascurrectcat[0],
      //   'lascurrectcat',
      //   categoryLookingAt,
      //   productDataResult
      // );
      if (!categoryLookingAt) {
        tempDataCollection = _.cloneDeep(
          productDataResult.filter(e => e.categoryName == lascurrectcat[0])
        );
        // alert(1)
      } else {
        // alert(2)
        tempDataCollection = _.cloneDeep(
          productDataResult.filter(
            e => e.categoryName.split('__')[2] == categoryLookingAt
          )
        );
      }
      /*
      productDataResult.forEach(element => {
        if (element.abs_string != null) {
          let filters = JSON.parse(element.abs_string);
          filters.forEach(eachfilter => {
            if ('rod-pieces' == eachfilter.attr) {
              // console.log(eachfilter['vals']['0']['value'],'f');
            }
            eachfilter.meta = JSON.parse(eachfilter.meta);
          });
          element.abs_string = filters;
        }
      });
      */

      let filterNamesBuilder = [];
      // console.log(tempDataCollection, 'tempDataCollection');
      tempDataCollection.forEach(eachProduct => {
        let groupBuilderFilter = _.groupBy(eachProduct.abs_string, 'attr');
        // console.log(groupBuilderFilter,'sortedFilters')
        _forOwn(groupBuilderFilter, (filterType, key) => {
          filterType.forEach(each => {
            let index = filterNamesBuilder.findIndex(each => each.attr === key);
            // console.log(filterNamesBuilder,'filterNamesBuilder',index)
            if (index === -1) {
              filterNamesBuilder.push({
                attr: key,
                name: each.meta.displayName,
                values: each.vals,
                valuesPerRow: each.meta.valuesPerRow,
                rank: each.rank,
              });
            } else {
              let newValues = filterNamesBuilder[index].values;
              each.vals.forEach(val => {
                if (
                  newValues.findIndex(each => each.value === val.value) === -1
                )
                  newValues.push(val);
              });
              filterNamesBuilder[index].values = newValues;
            }
          });
        });
      });

      // console.log(filterNamesBuilder,'category2')
      const sortedFiltersForBuilder = sortFilterValues(filterNamesBuilder);
      // console.log(sortedFiltersForBuilder,'sortedFiltersForBuilder')
      sortedFiltersForBuilder.sort(function(a, b) {
        return parseFloat(a.rank) - parseFloat(b.rank);
      });
      // SetMasterFilterOptions(sortedFiltersForBuilder);
      // setCurrentFilterData(sortedFiltersForBuilder);
      // console.log(sortedFiltersForBuilder,'sortedFiltersForBuilder')

      // setmasterProFilterData(sortedFiltersForBuilder);

      let productDetails;
      if (!categoryLookingAt) {
        let customFistCat = [];
        outfitList.filter(de => {
          let check = [];
          if (configData.possible_categories != undefined) {
            check = [
              ...configData.default_categories,
              ...configData.possible_categories,
            ].filter(e => {
              return de.categoryCurrent != e.display_name;
            });
          } else {
            check = [...configData.default_categories].filter(e => {
              return de.categoryCurrent != e.display_name;
            });
          }
          customFistCat = check;
        });
        // console.log(customFistCat[0], 'customFistCat');
        if (outfitList.length != 0) {
          productDetails = await fetchEcommerceData(
            productDataResult,
            // productDataResult.filter(e=>e.groupset == lascurrectcat[lascurrectcat.length-1]),
            // InitialData.meta.builder.component_types.REQUIRED[1]
            customFistCat[0]
            // [...configData.default_categories,...configData.possible_categories].filter(e=>e.display_name !== outfitList[0].categoryCurrent )[0]
          );
        } else {
          productDetails = await fetchEcommerceData(
            productDataResult,
            // productDataResult.filter(e=>e.groupset == lascurrectcat[lascurrectcat.length-1]),
            InitialData.meta.builder.component_types.REQUIRED[0]
            // [...configData.default_categories,...configData.possible_categories].filter(e=>e.display_name !== outfitList[0].categoryCurrent )[0]
          );

          // console.log(productDataResult,'newsortedProductsnewsortedProductsnewsortedProducts',productDetails,InitialData.meta.builder.component_types.REQUIRED[0])
        }
        // alert(1 + categoryLookingAt);
      } else {
        // alert(2 + categoryLookingAt);
        productDetails = await fetchEcommerceData(
          // productDataResult.filter(
          //   e => e.groupset.split('__')[2] == categoryLookingAt
          // ),
          productDataResult,
          // productDataResult.filter(e=>e.groupset == lascurrectcat[lascurrectcat.length-1]),
          // InitialData.meta.builder.component_types.REQUIRED[0]
          categoryLookingAt
        );
        // if(productDetails == undefined){
        //   productDetails = await fetchEcommerceData(
        //     productDataResult.filter(
        //       e => e.groupset.split('__')[2] != categoryLookingAt
        //     ),
        //     // productDataResult.filter(e=>e.groupset == lascurrectcat[lascurrectcat.length-1]),
        //     // InitialData.meta.builder.component_types.REQUIRED[0]
        //     categoryLookingAt
        //   );
        // }
      }
      // productDataResult.forEach(e => {
      //   console.log(e.groupset.split('__')[2], categoryLookingAt);
      // });
      if (productDetails != undefined) {
        const mergedProductData = DCABSdataApi.mergeCompatioDataWithProductData(
          productDetails,
          InitialData,
          categoryLookingAt
        );
        // alert(1)
        // console.log(mergedProductData, 'mergedProductData');
        // console.log(
        //   productDetails,
        //   InitialData,
        //   categoryLookingAt,
        //   'productDetails',
        //   mergedProductData,
        //   OtherCatData
        // );
        newsortedProducts = sortProductList(sortOrder, mergedProductData);

        // console.log(
        //   newsortedProducts,
        //   'productDetailsproductDetailsproductDetailsproductDetails'
        // );
        const selectedCats =
          configData.input != undefined &&
          configData.input.product_selections != null
            ? Object.keys(configData.input.product_selections)
            : [];
        const updatedSourceProduct = outfitList.find(
          each => each.isSourceProduct
        );
        // console.log(configData, 'configData');
        if (updatedSourceProduct) {
          updatedSourceProduct.categoryName = selectedCats[0];
          const newFinalArray = [...finalArray];
          newFinalArray[0] = selectedCats[0];
          //setFinalArray(newFinalArray);
        }
        //gauravname
        newsortedProducts.forEach(element => {
          element.abs_string = JSON.parse(element.abs_string);
          if (element.abs_string != null) {
            element.abs_string.forEach(elementAbs => {
              elementAbs.meta = JSON.parse(elementAbs.meta);
            });
          }
        });

        setMasterVariantList(newsortedProducts);
        setsortedProducts(newsortedProducts);
        // console.log(lascurrectcat,'lascurrectcat')
        if (!categoryLookingAt) {
          getCollapsedProductData(
            newsortedProducts,
            lascurrectcat[0].split('__')[2]
          );
          // sent filter request here
        } else {
          getCollapsedProductData(newsortedProducts, categoryLookingAt);
        }
        // setLoading(false);
        setDcDisplay('dc-container-show');
        window.$('div').removeClass('blank-builder-set');
        window.$('div.blankbuilderloading').remove();
        setLoader(false);
      } else {
        setCollapsedProductData([]);
      }
    } else {
      // configData = Object.assign(InitialData.configuratorData, {
      //   categoriesLeft: InitialData.categoriesLeft,
      //   input: InitialData.input,
      // });
      // setConfigData([]);
      setCollapsedProductData([]);
      setLoading(false);
      setCloneForFliter([]);
      setAppliedFilters(null);
      setAfterApplyFilter(null);

      setCurrentFilterData([]);
      SetMasterFilterOptions([]);
      setmasterProFilterData([]);

      // setAfterApplyFilterNeu(null);
      // console.log(preSelectedData,'fasdf')
      const availbalCat =
        InitialData.meta.builder.component_types.REQUIRED.length +
        InitialData.meta.builder.component_types.OPTIONAL.length;

      //  console.log(optiopLoad,preSelectedData.map(x => x.categoryNames ? x.categoryNames : x.categoryCurrent),'preSelectedData.map(x => x.categoryName).length')
      // console.log(availbalCat, 'availbalCat');

      //  console.log(preSelectedData,availbalCat,'preSelectedData,availbalCat')
      if (preSelectedData != undefined) {
        configData = Object.assign(InitialData.meta.builder.component_types, {
          categoriesLeft: InitialData.meta.builder.component_types.REQUIRED,
          default_categories: InitialData.meta.builder.component_types.REQUIRED,
          possible_categories:
            InitialData.meta.builder.component_types.OPTIONAL,
          input: InitialData.meta.builder.model,
        });

        setConfigData(configData);

        console.log(preSelectedData, 'fsdf', availbalCat);
        if (
          availbalCat ===
          preSelectedData.map(x => x.categoryName).length - 1
        ) {
          SetIsFull(true);
          setDcDisplay('dc-container-show');
          window.$('div').removeClass('blank-builder-set');
          window.$('div.blankbuilderloading').remove();
          setLoader(false);
          setLoading(false);
        } else {
          setDcDisplay('dc-container-show');
          window.$('div').removeClass('blank-builder-set');
          window.$('div.blankbuilderloading').remove();
          setLoader(false);
          setLoading(false);
        }
      }
    }
    /* old else option insted of above else
    {
      // configData = Object.assign(InitialData.configuratorData, {
      //   categoriesLeft: InitialData.categoriesLeft,
      //   input: InitialData.input,
      // });
      // setConfigData([]);
      setCollapsedProductData([]);
      setLoading(false);
      setCloneForFliter([]);
      setAppliedFilters(null);
      setAfterApplyFilter(null);

      setCurrentFilterData([]);
      SetMasterFilterOptions([]);
      setmasterProFilterData([]);

      // setAfterApplyFilterNeu(null);
      // console.log(preSelectedData,'fasdf')
      const availbalCat =
        InitialData.meta.builder.component_types.REQUIRED.length;

      // console.log(preSelectedData.map(x => x.categoryName).length,'preSelectedData.map(x => x.categoryName).length')
      // console.log(availbalCat, 'availbalCat');

      if (preSelectedData != undefined) {
        if (availbalCat === preSelectedData.map(x => x.categoryName).length) {
          SetIsFull(true);
        } 
      }
    }
      */
  };

  const fetchDataAfteraddprotoCart = async (
    outfitProducts,
    categoryLookingAt,
    filteroptions
  ) => {
    // alert(categoryLookingAt)
    // console.log(categoryLookingAt.categoryName,'categoryLookingAt')
    const compatioCategoryData = await DCABSdataApi.getCategoryDataByProductSku(
      outfitProducts,
      categoryLookingAt,
      filteroptions,
      modelId
    );
    let newsortedProducts = [];
    let configData = [];
    const InitialData = compatioCategoryData;
    if (
      InitialData !== undefined &&
      Object.entries(InitialData.results).length != 0
    ) {
      const productDataResult = [];
      const lascurrectcat = [];
      for (const [key, value] of Object.entries(InitialData.results)) {
        // console.log(key,value,'prodductDataResult');
        value.forEach(element => {
          element = {
            abs_string: JSON.parse(element.abs_string),
            image: element.image,
            name: element.name,
            parent_product_id: element.parent_product_id,
            product: element.product,
            variant_id: element.variant_id,
            groupset: key,
            categoryName: key,
          };
          if (element.abs_string != null) {
            element.abs_string.forEach(ae => {
              ae.meta = JSON.parse(ae.meta);
            });
          }
          // console.log(element,'element')
          // console.log(element.abs_string.map(ae=>JSON.parse(ae.meta)),'element')
          productDataResult.push(element);
        });

        lascurrectcat.push(key);
      }

      lascurrectcat.sort(function(a, b) {
        return a.split('__')[0].localeCompare(b);
      });

      if (!categoryLookingAt) {
        // alert(lascurrectcat[lascurrectcat.length-1].split('__')[2]+'+'+categoryLookingAt)
        setCurrentCategory(lascurrectcat[0].split('__')[2]);
      } else {
        // alert(lascurrectcat[lascurrectcat.length-1].split('__')[2]+'-'+categoryLookingAt)
        setCurrentCategory(categoryLookingAt);
      }
      let catonesec = InitialData.meta.builder.component_types.REQUIRED.map(
        each => each.display_name
      );

      let cattwosect = [];
      if (InitialData.meta.builder.component_types.OPTIONAL != undefined) {
        cattwosect = InitialData.meta.builder.component_types.OPTIONAL.map(
          each => each.display_name
        );
      } else {
        cattwosect = [];
      }
      // console.log(catonesec,'cattwosectforBuilder')
      // console.log("fasdf",cattwosect)
      SetCategoryListPreSets(catonesec);
      SetOptionalListPreSets(cattwosect);
      // console.log(catonesec,cattwosect,'SetOptionalListPreSetsSetOptionalListPreSets')
      configData = Object.assign(InitialData.meta.builder.component_types, {
        categoriesLeft: InitialData.meta.builder.component_types.REQUIRED,
        default_categories: InitialData.meta.builder.component_types.REQUIRED,
        possible_categories: InitialData.meta.builder.component_types.OPTIONAL,
        input: InitialData.meta.builder.model,
      });

      // console.log(configData,'configData')
      setConfigData(configData);
      // setCurrentFilterData(InitialData.attributes);
      setCurrentFilterData([]);
      // alert(InitialData.categoryLookingAt)
      //Object.keys(InitialData.meta.selection_details)[0].split('__')[2]

      // console.log(productDataResult.filter(e=>e.groupset == lascurrectcat[lascurrectcat.length-1]),'prodductDataResult',lascurrectcat[lascurrectcat.length-1])
      let tempDataCollection;
      // console.log(
      //   lascurrectcat[0],
      //   'lascurrectcat',
      //   categoryLookingAt,
      //   productDataResult
      // );
      if (!categoryLookingAt) {
        tempDataCollection = _.cloneDeep(
          productDataResult.filter(e => e.categoryName == lascurrectcat[0])
        );
        // alert(1)
      } else {
        // alert(2)
        tempDataCollection = _.cloneDeep(
          productDataResult.filter(
            e => e.categoryName.split('__')[2] == categoryLookingAt
          )
        );
      }

      let filterNamesBuilder = [];
      // console.log(tempDataCollection, 'tempDataCollection');
      tempDataCollection.forEach(eachProduct => {
        let groupBuilderFilter = _.groupBy(eachProduct.abs_string, 'attr');
        // console.log(groupBuilderFilter,'sortedFilters')
        _forOwn(groupBuilderFilter, (filterType, key) => {
          filterType.forEach(each => {
            let index = filterNamesBuilder.findIndex(each => each.attr === key);
            // console.log(filterNamesBuilder,'filterNamesBuilder',index)
            if (index === -1) {
              filterNamesBuilder.push({
                attr: key,
                name: each.meta.displayName,
                values: each.vals,
                valuesPerRow: each.meta.valuesPerRow,
                rank: each.rank,
              });
            } else {
              let newValues = filterNamesBuilder[index].values;
              each.vals.forEach(val => {
                if (
                  newValues.findIndex(each => each.value === val.value) === -1
                )
                  newValues.push(val);
              });
              filterNamesBuilder[index].values = newValues;
            }
          });
        });
      });

      // console.log(filterNamesBuilder,'category2')
      const sortedFiltersForBuilder = sortFilterValues(filterNamesBuilder);
      // console.log(sortedFiltersForBuilder,'sortedFiltersForBuilder')
      sortedFiltersForBuilder.sort(function(a, b) {
        return parseFloat(a.rank) - parseFloat(b.rank);
      });
      // SetMasterFilterOptions(sortedFiltersForBuilder);
      // setCurrentFilterData(sortedFiltersForBuilder);
      // console.log(sortedFiltersForBuilder,'sortedFiltersForBuilder')

      // setmasterProFilterData(sortedFiltersForBuilder);

      let productDetails = [];
      if (!categoryLookingAt) {
        let customFistCat = [];
        outfitList.filter(de => {
          let check = [];
          if (configData.possible_categories != undefined) {
            check = [
              ...configData.default_categories,
              ...configData.possible_categories,
            ].filter(e => {
              return de.categoryCurrent != e.display_name;
            });
          } else {
            check = [...configData.default_categories].filter(e => {
              return de.categoryCurrent != e.display_name;
            });
          }
          customFistCat = check;
        });
        // console.log(customFistCat[0], 'customFistCat');
        if (outfitList.length != 0) {
          productDetails = await fetchEcommerceData(
            productDataResult,
            // productDataResult.filter(e=>e.groupset == lascurrectcat[lascurrectcat.length-1]),
            // InitialData.meta.builder.component_types.REQUIRED[1]
            customFistCat[0]
            // [...configData.default_categories,...configData.possible_categories].filter(e=>e.display_name !== outfitList[0].categoryCurrent )[0]
          );
        } else {
          productDetails = await fetchEcommerceData(
            productDataResult,
            // productDataResult.filter(e=>e.groupset == lascurrectcat[lascurrectcat.length-1]),
            InitialData.meta.builder.component_types.REQUIRED[0]
            // [...configData.default_categories,...configData.possible_categories].filter(e=>e.display_name !== outfitList[0].categoryCurrent )[0]
          );
        }
        // alert(1 + categoryLookingAt);
      } else {
        // alert(2 + categoryLookingAt);
        productDetails = await fetchEcommerceData(
          // productDataResult.filter(
          //   e => e.groupset.split('__')[2] == categoryLookingAt
          // ),
          productDataResult,
          // productDataResult.filter(e=>e.groupset == lascurrectcat[lascurrectcat.length-1]),
          // InitialData.meta.builder.component_types.REQUIRED[0]
          categoryLookingAt
        );
        // if(productDetails == undefined){
        //   productDetails = await fetchEcommerceData(
        //     productDataResult.filter(
        //       e => e.groupset.split('__')[2] != categoryLookingAt
        //     ),
        //     // productDataResult.filter(e=>e.groupset == lascurrectcat[lascurrectcat.length-1]),
        //     // InitialData.meta.builder.component_types.REQUIRED[0]
        //     categoryLookingAt
        //   );
        // }
      }
      // productDataResult.forEach(e => {
      //   console.log(e.groupset.split('__')[2], categoryLookingAt);
      // });
      // console.log(productDetails, 'productDetails');
      if (productDetails != undefined && productDetails.length != 0) {
        const mergedProductData = DCABSdataApi.mergeCompatioDataWithProductData(
          productDetails,
          InitialData,
          categoryLookingAt
        );
        // console.log(mergedProductData, 'mergedProductData');
        // console.log(
        //   productDetails,
        //   InitialData,
        //   categoryLookingAt,
        //   'productDetails',
        //   mergedProductData,
        //   OtherCatData
        // );
        newsortedProducts = sortProductList(sortOrder, mergedProductData);

        const selectedCats =
          configData.input != undefined &&
          configData.input.product_selections != null
            ? Object.keys(configData.input.product_selections)
            : [];
        const updatedSourceProduct = outfitList.find(
          each => each.isSourceProduct
        );
        // console.log(configData, 'configData');
        if (updatedSourceProduct) {
          updatedSourceProduct.categoryName = selectedCats[0];
          const newFinalArray = [...finalArray];
          newFinalArray[0] = selectedCats[0];
          //setFinalArray(newFinalArray);
        }
        newsortedProducts.forEach(element => {
          element.abs_string = JSON.parse(element.abs_string);
          if (element.abs_string != null) {
            element.abs_string.forEach(elementAbs => {
              elementAbs.meta = JSON.parse(elementAbs.meta);
            });
          }
        });

        setMasterVariantList(newsortedProducts);
        setsortedProducts(newsortedProducts);
        // console.log(lascurrectcat,'lascurrectcat')
        // console.log(newsortedProducts,'newsortedProductsnewsortedProductsnewsortedProducts')
        if (!categoryLookingAt) {
          getCollapsedProductData(
            newsortedProducts,
            lascurrectcat[0].split('__')[2]
          );
          // sent filter request here
        } else {
          getCollapsedProductData(newsortedProducts, categoryLookingAt);
        }
        // setLoading(false);
        setDcDisplay('dc-container-show');
        window.$('div').removeClass('blank-builder-set');
        window.$('div.blankbuilderloading').remove();
        // setLoader(false);
      } else {
        // setCollapsedProductData([]);
      }
    } else {
      // configData = Object.assign(InitialData.configuratorData, {
      //   categoriesLeft: InitialData.categoriesLeft,
      //   input: InitialData.input,
      // });
      // setConfigData([]);
      setCollapsedProductData([]);
      // setLoading(false)
      setAppliedFilters(null);
      setAfterApplyFilter(null);
      // setAfterApplyFilterNeu(null);
      // console.log(preSelectedData,'fasdf')
      const availbalCat =
        InitialData.meta.builder.component_types.REQUIRED.length;

      // console.log(preSelectedData.map(x => x.categoryName).length,'preSelectedData.map(x => x.categoryName).length')
      // console.log(availbalCat, 'availbalCat');

      if (preSelectedData != undefined) {
        if (availbalCat === preSelectedData.map(x => x.categoryName).length) {
          SetIsFull(true);
        }
      }
    }
  };

  const fetchDataCategorywise = async (
    outfitProducts,
    categoryLookingAt,
    filteroptions
  ) => {
    // console.log(
    //   outfitProducts,
    //   categoryLookingAt,
    //   filteroptions,
    //   'outfitProducts,categoryLookingAt,filteroptions'
    // );
    const compatioCategoryData = await DCABSdataApi.getCategoryDataByCategory(
      outfitProducts,
      categoryLookingAt,
      filteroptions,
      modelId
    );

    let newsortedProducts = [];
    let configData = [];
    const InitialData = compatioCategoryData;
    if (
      InitialData !== undefined &&
      Object.entries(InitialData.results).length != 0
    ) {
      // console.log(compatioCategoryData.meta.builder.component_types.REQUIRED, 'InitialData');
      // console.log(InitialData,'InitialData')
      const productDataResult = [];
      const lascurrectcat = [];
      for (const [key, value] of Object.entries(InitialData.results)) {
        // console.log(key,value,'prodductDataResult');
        value.forEach(element => {
          element = {
            abs_string: JSON.parse(element.abs_string),
            image: element.image,
            name: element.name,
            parent_product_id: element.parent_product_id,
            product: element.product,
            variant_id: element.variant_id,
            groupset: key,
            categoryName: key,
          };
          if (element.abs_string != null) {
            element.abs_string.forEach(ae => {
              ae.meta = JSON.parse(ae.meta);
            });
          }
          if (element.abs_string != undefined) {
            // console.log(element,'element')
            productDataResult.push(element);
            // console.log(element.abs_string.map(ae=>JSON.parse(ae.meta)),'element')
          }
        });

        lascurrectcat.push(key);
      }

      lascurrectcat.sort(function(a, b) {
        return a.split('__')[0].localeCompare(b);
      });

      let tempDataCollection;
      tempDataCollection = _.cloneDeep(
        productDataResult.filter(e => e.categoryName == lascurrectcat[0])
      );

      /*
      let filterNamesBuilder = [];
      tempDataCollection.forEach(eachProduct => {
        let groupBuilderFilter = _.groupBy(eachProduct.abs_string, 'attr');
        // console.log(groupBuilderFilter,'sortedFilters')
        _forOwn(groupBuilderFilter, (filterType, key) => {
          filterType.forEach(each => {
            let index = filterNamesBuilder.findIndex(each => each.attr === key);
            // console.log(filterNamesBuilder,'filterNamesBuilder',index)
            if (index === -1) {
              filterNamesBuilder.push({
                attr: key,
                name: each.meta.displayName,
                values: each.vals,
                valuesPerRow: each.meta.valuesPerRow,
                rank: each.rank,
              });
            } else {
              let newValues = filterNamesBuilder[index].values;
              each.vals.forEach(val => {
                if (
                  newValues.findIndex(each => each.value === val.value) === -1
                )
                  newValues.push(val);
              });
              filterNamesBuilder[index].values = newValues;
            }
          });
        });
      });
      */

      let fdas = await fetchEcommerceData(
        tempDataCollection,
        // productDataResult.filter(e=>e.groupset == lascurrectcat[lascurrectcat.length-1]),
        lascurrectcat[0]
        // [...configData.default_categories,...configData.possible_categories].filter(e=>e.display_name !== outfitList[0].categoryCurrent )[0]
      );

      // console.log(fdas,tempDataCollection,'productDetailsproductDetailsproductDetails');
      // getCollapsedProductData(
      //   fdas,
      //   lascurrectcat[0].split('__')[2]
      // );

      // console.log(filterNamesBuilder,'category2')
      // const sortedFiltersForBuilder = sortFilterValues(filterNamesBuilder);
      // sortedFiltersForBuilder.sort(function(a, b) {
      //   return parseFloat(a.rank) - parseFloat(b.rank);
      // });
      // console.log(sortedFiltersForBuilder,'sortedFiltersForBuilder')

      // SetMasterFilterOptions(sortedFiltersForBuilder);
      // setCurrentFilterData(sortedFiltersForBuilder);

      let productDetails;
      productDetails = await fetchEcommerceData(
        productDataResult,
        categoryLookingAt
      );

      if (productDetails != undefined) {
        const mergedProductData = await DCABSdataApi.mergeCompatioDataWithProductData(
          productDetails,
          InitialData,
          categoryLookingAt
        );

        newsortedProducts = sortProductList(sortOrder, mergedProductData);

        const selectedCats =
          configData.input != undefined &&
          configData.input.product_selections != null
            ? Object.keys(configData.input.product_selections)
            : [];
        const updatedSourceProduct = outfitList.find(
          each => each.isSourceProduct
        );
        if (updatedSourceProduct) {
          updatedSourceProduct.categoryName = selectedCats[0];
          const newFinalArray = [...finalArray];
          newFinalArray[0] = selectedCats[0];
          setFinalArray(newFinalArray);
        }
        setMasterVariantList(newsortedProducts);
        setsortedProducts(newsortedProducts);
        // console.log(newsortedProducts,'newsortedProducts',categoryLookingAt.split('__')[2])
        getCollapsedProductDataforCat(newsortedProducts, categoryLookingAt);
        getCollapsedProductData(
          newsortedProducts,
          categoryLookingAt.split('__')[2]
        );
        // setLoading(false);
        setDcDisplay('dc-container-show');
        window.$('div').removeClass('blank-builder-set');
        window.$('div.blankbuilderloading').remove();
      }
    }
  };

  const [filterActivate, SetfilterActivate] = useState(false);
  const [CurrectType, SetCurrectType] = useState(false);

  const updateValueToFilters = (displayName, type, value, isFilterAdd) => {
    SetCurrectType(type);
    SetfilterActivate(true);
    SetLastFilterSelect(type);
    let newFilters = appliedFilters === null ? [] : [...appliedFilters];
    let ifFilterPresent = newFilters.find(
      filter => filter.name === type && filter.value === value
    );
    if (ifFilterPresent != undefined) {
      if (isFilterAdd == true) {
        newFilters = newFilters.filter(
          each =>
            each.name != ifFilterPresent.name ||
            each.value != ifFilterPresent.value
        );
      }
      setAppliedFilters(newFilters);
    } else {
      if (isFilterAdd == false) {
        newFilters.push({
          name: type,
          displayName: displayName,
          value: value,
        });
        // console.log(type,displayName,value)
        setAppliedFilters(newFilters);
      }
    }
    if (newFilters.length === 0) {
      // localStorage.removeItem();
    } else {
      localStorage.setItem(currentCategory, JSON.stringify(newFilters));
      // console.log('local storage', localStorage);
    }
  };

  const updateCategoryWiseFilters = newfilters => {
    const categoryFilterData = _.cloneDeep(categoryWiseFilters);
    const itemToUpdate = categoryFilterData.find(
      each => each.categoryName === currentCategory
    );
    if (itemToUpdate === undefined && currentCategory != '') {
      categoryFilterData.push({
        categoryName: currentCategory,
        filterData: newfilters,
      });
    } else if (
      itemToUpdate !== undefined &&
      itemToUpdate.filterData !== undefined
    ) {
      itemToUpdate.filterData = newfilters;
    }
    setApplySelectedFilters(false);
    setCategoryWiseFilters([]);
    setCollapsedProductData(collapsedProductDataFilter);
    // CreateFilteredNew(collapsedProductDataFilter)
    // console.log(collapsedProductDataFilter,itemToUpdate,collapsedProductDataFilter, 'categoryFilterData');
  };
  // (masterProData)
  // (masterProFilterData)
  const updateProductList = (collapsedProductDataa, appliedFilterss) => {
    // setLoading(true)
    // const [masterProData, setmasterProData] = useState([]);
    // const [masterProFilterData, setmasterProFilterData] = useState([]);

    // console.log(collapsedProductDataa, masterProFilterData, 'rohan');
    let applicableAttributesFilter = [];
    let afterFilterNextSet = [];

    let newData = [];
    let filterGroups = _.groupBy(appliedFilterss, 'name');
    const filterSets = [];
    _forOwn(filterGroups, (filterObj, key) => {
      let values = [];
      filterObj.forEach(each => values.push(each.value));
      filterSets.push({ attr: key, values: values });
    });
    const rootProductss = _.cloneDeep(
      collapsedProductDataa.map(e => e.categoryData)[0]
    );
    const lastFilterProductss =
      _.cloneDeep(collapsedProductDataa.map(e => e.categoryData)[0]) !=
      undefined
        ? _.cloneDeep(collapsedProductDataa.map(e => e.categoryData)[0])
        : [];

    const filterData =
      _.cloneDeep(collapsedProductDataa.map(e => e.categoryData)[0]) !=
      undefined
        ? _.cloneDeep(collapsedProductDataa.map(e => e.categoryData)[0])
        : [];

    let dataList = [];
    if (rootProductss != undefined) {
      dataList = rootProductss.filter(x => {
        let productMatch = false;
        //variants looping
        let checkvariant = [];
        for (const y of x.variants) {
          // x.variants.forEach(y=> {
          const matchedFilter = [];
          const matchedFilterfortow = [];
          // filter attributes looping

          if (y.abs_string != undefined) {
            filterSets.forEach(filterItem => {
              // console.log(filterItem, 'filterSets');
              const matchedVariantd = y.abs_string.filter(
                z =>
                  z.attr === filterItem.attr ||
                  z.vals[0].value == filterItem.values[0]
              );
              const matchedVariant = y.abs_string.find(
                z =>
                  z.attr === filterItem.attr ||
                  z.vals[0].value == filterItem.values[0]
              );
              y.abs_string.forEach(z => {
                if (z.attr == filterItem.attr) {
                  let gs = z.vals.filter(t => {
                    if (filterItem.values.length > 1) {
                      let ty = filterItem.values.filter(y => {
                        if (y == t.value) {
                          // console.log(z.attr , filterItem.attr,'part tow', z.vals , filterItem,y,t.value)
                          return y;
                        }
                      });
                      if (ty.length != 0) {
                        return t;
                      }
                    } else {
                      if (filterItem.values[0] == t.value) {
                        return t;
                      }
                      // console.log(t,'testFilter')
                      // console.log(z.attr , filterItem.attr,'[part one]', z.vals , filterItem.values[0] ,t.value)
                    }
                  });
                  if (gs.length != 0) {
                    // console.log(z,'z',z.attr==filterItem.attr)
                    matchedFilter.push(true);
                  }
                }
                // console.log(z,'z')
                // console.log(z,filterItem,'testFilter', z.attr == filterItem.attr )
                // return z
              });
              // console.log(matchedVariantd[0].attr ,matchedVariant)
              // console.log(y.abs_string, filterItem ,'fi')
              if (matchedVariantd.length != 0) {
                if (matchedVariant != undefined) {
                  if (matchedVariantd[0].vals.length > 1) {
                    // console.log(matchedVariantd[0].vals.length,'matchedVariantd[0].vals.length')
                    // console.log(filterItem.values.includes(matchedVariantd[0].vals[0].value),matchedVariantd[0] ,'matchedVariant')
                    var i = 0;
                    matchedVariantd[0].vals.filter(et => {
                      if (
                        filterItem.values.includes(
                          matchedVariantd[0].vals[i].value
                        ) == true
                      ) {
                        // matchedFilter.push(
                        //   filterItem.values.includes(
                        //     matchedVariantd[0].vals[i].value
                        //   )
                        // );
                        // console.log(filterItem.values.includes(matchedVariantd[0].vals[i].value),'matchedVariant')
                      }
                      i++;
                    });
                  } else {
                    // console.log(filterItem.values.includes(matchedVariantd[0].vals[0].value),matchedVariantd[0] ,'matchedVariant')
                    if (
                      filterItem.values.includes(
                        matchedVariantd[0].vals[0].value
                      ) == true
                    ) {
                      // matchedFilter.push(
                      //   filterItem.values.includes(matchedVariantd[0].vals[0].value)
                      // );
                    }
                  }
                  // console.log(filterItem.values.includes(matchedVariantd[0].vals[0].value),filterItem.values.includes(matchedVariantd[1].vals[0].value) ,'matchedVariant')
                }
                // console.log(filterItem ,y,'matchedVariant',matchedVariantd,filterSets.length)
                // console.log(filterItem.values, matchedVariant.vals[0].value ,y,'matchedVariant')
              } else if (matchedVariant != undefined) {
                // console.log(filterItem.values, matchedVariant.vals[0].value ,y,'matchedVariant')
                matchedFilter.push(
                  filterItem.values.includes(matchedVariant.vals[0].value)
                );
              }
            });
            // test.push('matchedFilters', matchedFilter.length, filterSets.length)
            x.variants = [];
            if (
              matchedFilter.every(x => x) &&
              matchedFilter.length == filterSets.length
            ) {
              checkvariant.push(y);
              productMatch = true;
            }
            x.variants = checkvariant;
          }
        }
        return productMatch;
      });
    }
    // console.log(dataList,'dataListTwo',rootProductss)

    newData = dataList ? dataList : [];

    const lastFilterProducts = lastFilterProductss.filter(x => {
      let productMatch = false;
      //variants looping
      let checkvariant = [];
      for (const y of x.variants) {
        // x.variants.forEach(y=> {
        const matchedFilter = [];
        const matchedFilterfortow = [];
        // filter attributes looping

        if (y.abs_string != undefined) {
          filterSets.forEach(filterItem => {
            if (filterItem.attr !== 'productVendor') {
              const matchedVariant = y.abs_string.find(
                z => z.attr === filterItem.attr
              );
              if (matchedVariant) {
                matchedFilter.push(
                  filterItem.values.includes(matchedVariant.vals[0].value)
                );
              }
            }
          });
          x.variants = [];
          if (matchedFilter.every(x => x) == true) {
            checkvariant.push(y);
            productMatch = true;
          }
          x.variants = checkvariant;
        }
      }
      return productMatch;
    });
    // console.log(masterFilterOptions,'masterFilterOptions',newData,filterSets,lastFilterProductss)
    let PrevFiltersest = masterFilterOptions.map(e => e.attr);
    // console.log(collapsedProductDataFilter,'rootProduct',newData,categorywiseData.map(e=>e.categoryData)[0])

    let finalProdNew = sortProductListApplyFilter(sortOrder, newData);
    let variantCount = [];
    finalProdNew.map(et => et.variants.map(ets => variantCount.push(ets)));

    setMasterVariantList(variantCount);
    let finalProd = [
      {
        categoryName: currentCategory,
        categoryData: finalProdNew,
      },
    ];

    // CreateFiltered(newData)
    // console.log(newData,'category0')
    // console.log(finalProdNew,'finalProdNew',finalProd)

    let filterNamesBuilders = [];
    newData.forEach(eachProduct => {
      eachProduct.variants.forEach(eachProductVariants => {
        let groupBuilderFilter = _.groupBy(
          eachProductVariants.abs_string,
          'attr'
        );
        // console.log(groupBuilderFilter,'groupBuilderFiltergroupBuilderFilter')
        _forOwn(groupBuilderFilter, (filterType, key) => {
          filterType.forEach(each => {
            let index = filterNamesBuilders.findIndex(
              each => each.attr === key
            );
            // console.log(filterNamesBuilder,'filterNamesBuilder',index)
            if (index === -1) {
              filterNamesBuilders.push({
                attr: key,
                name: each.meta.displayName,
                values: each.vals,
                valuesPerRow: each.meta.valuesPerRow,
                rank: each.rank,
              });
            } else {
              let newValues = filterNamesBuilders[index].values;
              each.vals.forEach(val => {
                if (
                  newValues.findIndex(each => each.value === val.value) === -1
                )
                  newValues.push(val);
              });
              filterNamesBuilders[index].values = newValues;
            }
          });
        });
      });
    });
    const sortedFiltersForBuilders = sortFilterValues(filterNamesBuilders);
    // console.log(
    //   sortedFiltersForBuilders,
    //   'sortedFiltersForBuilder',
    //   currentCategory
    // );

    // collapsedProductData
    // console.log(finalProd,'finalProd')
    let DataForUpdateFilterAfterthat = _.cloneDeep(newData);
    // console.log(DataForUpdateFilterAfterthat,newData,'DataForUpdateFilterAfterthatDataForUpdateFilterAfterthat')
    DataForUpdateFilterAfterthat.forEach(eachProduct => {
      eachProduct.variants.forEach(variant => {
        let group = _.groupBy(variant.abs_string, 'attr');
        // console.log(group,'eachProducteachProduct')
        _forOwn(group, (filterType, key) => {
          filterType.forEach(each => {
            // console.log(each,'each')
            let index = applicableAttributesFilter.findIndex(
              each => each.attr === key
            );

            if (index === -1) {
              applicableAttributesFilter.push({
                attr: key,
                name: each.meta.displayName,
                values: each.vals,
                valuesPerRow: each.meta.valuesPerRow,
                rank: each.rank,
              });
            } else {
              let newValues = applicableAttributesFilter[index].values;
              each.vals.forEach(val => {
                if (
                  newValues.findIndex(each => each.value === val.value) === -1
                ) {
                  newValues.push(val);
                }
              });
              applicableAttributesFilter[index].values = newValues;
            }
          });
        });
      });
    });

    let applicableAttributesFilterforVendor = [];
    lastFilterProducts.forEach(eachProduct => {
      eachProduct.variants.forEach(variant => {
        let group = _.groupBy(variant.abs_string, 'attr');
        // console.log(group,'eachProducteachProduct')
        _forOwn(group, (filterType, key) => {
          filterType.forEach(each => {
            // console.log(each,'each')
            let index = applicableAttributesFilterforVendor.findIndex(
              each => each.attr === key
            );

            if (index === -1) {
              applicableAttributesFilterforVendor.push({
                attr: key,
                name: each.meta.displayName,
                values: each.vals,
                valuesPerRow: each.meta.valuesPerRow,
                rank: each.rank,
              });
            } else {
              let newValues = applicableAttributesFilterforVendor[index].values;
              each.vals.forEach(val => {
                if (
                  newValues.findIndex(each => each.value === val.value) === -1
                ) {
                  newValues.push(val);
                }
              });
              applicableAttributesFilterforVendor[index].values = newValues;
            }
          });
        });
      });
    });

    PrevFiltersest.forEach(b => {
      if (LastFilterSelect != b) {
        applicableAttributesFilter.forEach(e => {
          if (e.attr != LastFilterSelect) {
            if (e.attr == b) {
              afterFilterNextSet.push(e);
            }
          }
        });
      } else {
        currentFilterData.forEach(e => {
          if (e.attr == LastFilterSelect) {
            afterFilterNextSet.push(e);
          }
        });
      }
    });

    let vendorfilterset = [];
    PrevFiltersest.forEach(b => {
      if (LastFilterSelect != b) {
        applicableAttributesFilterforVendor.forEach(e => {
          if (e.attr != LastFilterSelect) {
            if (e.attr == 'productVendor') {
              vendorfilterset.push(e);
            }
          }
        });
      }
    });
    let filtermerger = [
      vendorfilterset[0],
      ...afterFilterNextSet.filter(
        e => e.attr != 'productVendor' || vendorfilterset[0] == undefined
      ),
    ];
    if (collapsedProductDataa.length != 0) {
      if (appliedFilters.length === 0) {
        // // setCurrentFilterData([...rootProduct]);
        // commented by KG-Compatio
        //comment this for testing , the reason i comment this when we applying filter and adding prodcut to cart its before loading new category data showing (based on product compatible line ) issue which we are facing same for after loadin blank builder category issue..
        // setCollapsedProductData(collapsedProductDataa);
        setCollapsedProductData(collapsedProductDataa);
        // setCurrentFilterData(filtermerger.filter(e => e != undefined));
        FilterUpdateData(
          [...filtermerger.filter(e => e != undefined)],
          '',
          collapsedProductDataa
        );
        // setCurrentFilterData(filtermerger.filter(e => e != undefined));
        // setCurrentFilterData(masterProFilterData);
        // console.log(collapsedProductDataa,filtermerger.filter(e=>e != undefined),masterProFilterData,'masterProFilterDatamasterProFilterData')
        // const [masterProData, setmasterProData] = useState([]);
        // const [masterProFilterData, setmasterProFilterData] = useState([]);
      } else {
        setCollapsedProductData([...finalProd]);
        // setCurrentFilterData([...afterFilterNextSet]);
        // setCurrentFilterData(sortFilterValues(filtermerger.filter(ey=>ey != undefined)));
        FilterUpdateData(
          [...filtermerger.filter(e => e != undefined)],
          LastFilterSelect,
          collapsedProductDataa
        );
        // console.log(sortFilterValues(filtermerger.filter(ey=>ey != undefined)),'sortFilterValuesBuilder(filtermerger))')
      }
    }
  };

  const FilterUpdateData = (
    filterData,
    LastFilterSelect,
    filterDataProductCloen
  ) => {
    // console.log(
    //   filterData,
    //   LastFilterSelect,
    //   filterDataProductCloen,
    //   // mainProductObject,
    //   'filterDataLastFilterSelectfilterDataProductCloen',
    //   appliedFilters
    // );
    // console.log(filterData,'filterData')
    // console.log(filterData,'filterDatafilterData')
    const updatedFilterAttData = [];
    filterData.forEach(es => {
      const rootproductmainclone = _.cloneDeep(
        filterDataProductCloen.map(e => e.categoryData)[0]
        // mainProductObject.map(e => e.categoryData)[0]
      );

      // console.log(filterDataProductCloen,mainProductObject,rootproductmainclone,'filterData,mainProductObject')
      const lastFilterProductsdata = [];
      if (es.attr != LastFilterSelect) {
        // console.log(
        //   es.attr + '+' + LastFilterSelect,
        //   es.attr == LastFilterSelect
        // );
        let filterGroups = _.groupBy(
          appliedFilters.filter(e => e.name != es.attr),
          'name'
        );
        const filterSets = [];
        // console.log(filterGroups,'filterGroups')
        _forOwn(filterGroups, (filterObj, key) => {
          let values = [];
          filterObj.forEach(each => values.push(each.value));
          filterSets.push({ attr: key, values: values });
        });
        rootproductmainclone.forEach(x => {
          let productMatch = false;
          //variants looping
          let checkvariant = [];
          // console.log(x, 'x');
          for (const y of x.variants) {
            // x.variants.forEach(y=> {
            const matchedFilter = [];
            // filter attributes looping

            if (y.abs_string != undefined) {
              filterSets.forEach(filterItem => {
                y.abs_string.forEach(z => {
                  if (z.attr == filterItem.attr) {
                    let gs = z.vals.filter(t => {
                      if (filterItem.values.length > 1) {
                        let ty = filterItem.values.filter(y => {
                          if (y == t.value) {
                            // console.log(z.attr , filterItem.attr,'part tow', z.vals , filterItem,y,t.value)
                            return y;
                          }
                        });
                        if (ty.length != 0) {
                          return t;
                        }
                      } else {
                        if (filterItem.values[0] == t.value) {
                          return t;
                        }
                        // console.log(t,'testFilter')
                        // console.log(z.attr , filterItem.attr,'[part one]', z.vals , filterItem.values[0] ,t.value)
                      }
                    });
                    if (gs.length != 0) {
                      // console.log(z,'z',z.attr==filterItem.attr)
                      matchedFilter.push(true);
                    }
                  }
                  // console.log(z,'z')
                  // console.log(z,filterItem,'testFilter', z.attr == filterItem.attr )
                  // return z
                });
              });
              x.variants = [];
              if (
                matchedFilter.every(x => x) == true &&
                matchedFilter.length == filterSets.length
              ) {
                // if (matchedFilter.every(x => x) == true) {
                checkvariant.push(y);
                productMatch = true;
              }
              x.variants = checkvariant;
              lastFilterProductsdata.push(x);
            }
          }
          // return productMatch;
        });
        let applicableAttributesFilterforVendor = [];
        lastFilterProductsdata.forEach(eachProduct => {
          eachProduct.variants.forEach(variant => {
            let groupe = _.groupBy(variant.abs_string, 'attr');
            // console.log(group,'eachProducteachProduct')
            _forOwn(groupe, (filterType, key) => {
              filterType.forEach(each => {
                if (each.attr == es.attr) {
                  let index = applicableAttributesFilterforVendor.findIndex(
                    each => each.attr === key
                  );

                  if (index === -1) {
                    applicableAttributesFilterforVendor.push({
                      attr: key,
                      name: each.meta.displayName,
                      values: each.vals,
                      valuesPerRow: each.meta.valuesPerRow,
                      rank: each.rank,
                    });
                  } else {
                    let newValues =
                      applicableAttributesFilterforVendor[index].values;
                    each.vals.forEach(val => {
                      if (
                        newValues.findIndex(
                          each => each.value === val.value
                        ) === -1
                      ) {
                        newValues.push(val);
                      }
                    });
                    applicableAttributesFilterforVendor[
                      index
                    ].values = newValues;
                  }
                }
              });
            });
          });
        });
        updatedFilterAttData.push(applicableAttributesFilterforVendor[0]);
      } else if (es.attr == LastFilterSelect) {
        // console.log(
        //   es.attr,
        //   LastFilterSelect,
        //   'es.attr != LastFilterSelect',
        //   es.attr == LastFilterSelect
        // );
        updatedFilterAttData.push(es);
        // console.log(es,'es',filterData)
      }
    });
    // console.log(
    //   updatedFilterAttData
    //     .filter(ed => ed != undefined)
    //     .sort(function(a, b) {
    //       return parseFloat(a.rank) - parseFloat(b.rank);
    //     }),
    //   'updatedFilterAttDataupdatedFilterAttData'
    // );
    // console.log(sortFilterValues(updatedFilterAttData.filter(ed => ed != undefined)),'sortFilterValues(updatedFilterAttData.filter(ed => ed != undefined))')
    // console.log(
    //   updatedFilterAttData.filter(ed => ed != undefined).length != 0,
    //   'updatedFilterAttData'
    // );

    // this logic add selected filter back in narrow filters , before that its hiding a selected filters from narrow filters but showing same one above the products
    updatedFilterAttData.find(e => {
      appliedFilters.filter(es => {
        if (e.attr == es.name && CurrectType != e.attr) {
          // let valueCHeck = e.values.hasOwnProperty(es.value)
          let valueCHeck = e.values.some(item => item.value === es.value);
          // let valueCHecdk = e.values.filter(item => item.value === es.value)
          //  console.log(valueCHeck,'dfa',e.values,es.value,valueCHecdk)
          if (valueCHeck == false) {
            // console.log(e,es)
            e.values.push({
              meta: {
                alt_text: '',
                display_value: es.value.replace('_', ' '),
                image_url: '',
              },
              value: es.value,
            });
          }
        }
      });
      //  console.log(es.name, es.value,evalu.value, es.value!=evalu.value);
      // console.log(e)
    });
    setCurrentFilterData([]);
    if (updatedFilterAttData.filter(ed => ed != undefined).length != 0) {
      setCurrentFilterData(
        sortFilterValues(
          updatedFilterAttData
            .filter(ed => ed != undefined)
            .sort(function(a, b) {
              return parseFloat(a.rank) - parseFloat(b.rank);
            })
        )
      );
    }
  };

  useEffect(() => {
    //setfirstTimeload, firstTimeload,
    // updateProductList(collapsedProductData, appliedFilters); ;
    if (categorywiseDataTrue == true) {
      // updateProductList(masterProData, appliedFilters);
      setcategorywiseDataTrue(false);
    }
    if (filterActivate == true) {
      if (appliedFilters !== null && categorywiseDataTrue == false) {
        if (appliedFilters.length != 0 && filtersAppliedoneTrue == false) {
          updateProductList(collapsedProductDataFilter, appliedFilters);
          // console.log(masterProData, 'masterProData',collapsedProductDataFilter,appliedFilters);

          // console.log(
          //   appliedFilters,
          //   collapsedProductData,
          //   'appliedFilters,collapsedProductData',
          //   appliedFilters
          // );

          // console.log(appliedFilters,'ro1',collapsedProductDataFilter);
        } else if (
          appliedFilters.length == 0 &&
          categorywiseDataTrue == false
        ) {
          // alert(1)

          // console.log(appliedFilters,'ro',collapsedProductDataFilter);
          updateProductList(collapsedProductDataFilter, []);
        }
      }
    }
    if (OpenPopReels == true) {
      setShowOptions(false);
    }
    if (appliedFilters !== null) {
      if (appliedFilters.length == 0 && filtersAppliedoneTrue == false) {
        // if(firstTimeload === true){

        if (checkCatFil !== true) {
          const variantList = outfitList.map(outfit => {
            if (outfit.categoryName !== 'Backing')
              return outfit.merchantProductSku;
          });
          // console.log(JSON.stringify(variantList),'variantListvariantList')
          if (proAdded == false) {
            if (selectDataAvailable != true && dataBlankData != true) {
              // setLoading(true);
              // setAfterApplyFilter(appliedFilters);
              // setAfterApplyFilterNeu(appliedFilters);
              // // updateCategoryWiseFilters(appliedFilters);

              // setAppliedFilters(appliedFilters);
              // fetchData(variantList, currentCategory, appliedFilters);
              // alert(currentCategory);
              // fetchData([], `Fly%20Rods`, appliedFilters);

              if (props.template !== `product`) {
                setOutfitList([]);
              }
              // console.log(5, appliedFilters, proAdded, ' proAdded');
              setCheckCatFil(false);
              setproAdded(false);

              setSelectDataAvailable(false);
              setdataBlankData(false);
              setfirstTimeload(false);
            }
          }
        }
        // }
      } else if (filtersAppliedoneTrue != 0 && filtersAppliedoneTrue == true) {
        // console.log(filtersAppliedone, 'filtersAppliedone');
        const variantList = outfitList.map(outfit => {
          if (outfit.categoryName !== 'Backing')
            return outfit.merchantProductSku;
        });
        // setLoading(true);
        // setAfterApplyFilter(filtersAppliedone);
        // updateCategoryWiseFilters(filtersAppliedone);
        // fetchData(variantList, currentCategory, appliedFilters);

        // console.log(4);
        // setSelectDataAvailable(false);
        setFiltersAppliedoneTrue(false);
        setFiltersAppliedone([]);
      }
    }
  }, [appliedFilters]);

  useEffect(() => {
    let ds = [];

    if (dse.length == 0 && appliedFilters == null) {
      ds = [];
    } else {
      if (dse.length == 0) {
        if (afterApplyFilter != null) {
          ds = [...afterApplyFilter];
          // alert(1);
        }
      } else {
        ds = [...appliedFilters];
        // alert(3);
      }
    }

    // console.log(afterApplyFilter, 'afterApplyFilter', dse, appliedFilters);
    const appliedcustom = [];

    // alert(applySelectedFilters+'applySelectedFilters')
    if (applySelectedFilters == true) {
      let dselect = false;
      let checTruFlse = false;

      appliedFilters.forEach((es, index) => {
        checTruFlse = es.name == applyFilterWise;
        if (checTruFlse == true) {
          ds.push(es);
        }
      });

      const result = ds.filter(
        (thing, index, self) =>
          index ===
          self.findIndex(
            t =>
              t.value === thing.value &&
              t.metaValue === thing.metaValue &&
              t.name === thing.name
          )
      );

      const variantList = outfitList.map(outfit => {
        if (outfit.categoryName !== 'Backing') return outfit.merchantProductSku;
      });

      setLoading(true);
      // console.log(currentCategory, '-', 3);
      if (currentCategory != '') {
        setSelectDataAvailable(false);
        setdataBlankData(false);
        const findStoreCategory = categoryWiseFilters.find(
          each => each.categoryName === currentCategory
        );
        // updateCategoryWiseFilters(result);

        setAppliedFilters(result);
        setAfterApplyFilter(result);
        setAfterApplyFilterNeu(result);
        // fetchData(variantList, currentCategory, result);
        // console.log(3, result, findStoreCategory);
      }
    }

    if (noSelectedData == true && dataBlankData == false) {
      const variantList = outfitList.map(outfit => {
        if (outfit.categoryName !== 'Backing') return outfit.merchantProductSku;
      });
      setLoading(true);
      setAfterApplyFilter(appliedFilters);
      setAfterApplyFilterNeu(appliedFilters);
      // fetchData([], currentCategory, appliedFilters);
      // console.log(6, 'gs', currentCategory, appliedFilters);
      setOutfitList([]);
      //preFiltersData
      const urlback = window.location.href;
      const urlbackSet = urlback.split('#')[0];
      window.history.pushState(
        'forward',
        null,
        urlbackSet + '#smartBuilder&blank=open'
      );
      setnoSelectedData(false);
      setdataBlankData(false);
    } else if (dataBlankData == true && noSelectedData == true) {
      const variantList = outfitList.map(outfit => {
        if (outfit.categoryName !== 'Backing') return outfit.merchantProductSku;
      });
      let catFilData = preFiltersData.filter(
        e => e.categoryName == currentCategory
      );
      setLoading(true);
      setAppliedFilters(catFilData[0].filterData);
      setAfterApplyFilter(catFilData[0].filterData);
      setAfterApplyFilterNeu(catFilData[0].filterData);
      // fetchData([], currentCategory, catFilData[0].filterData);
      // console.log(2, 'gst', currentCategory, appliedFilters);

      // console.log(catFilData[0].filterData, 'gg', appliedFilters);

      setOutfitList([]);
      const urlback = window.location.href;
      const urlbackSet = urlback.split('#')[0];
      window.history.pushState(
        'forward',
        null,
        urlbackSet + '#smartBuilder&blank=open'
      );
      setdataBlankData(false);
    } else if (selectDataAvailable == true && dataBlankData == true) {
      const variantList = outfitList.map(outfit => {
        if (outfit.categoryName !== 'Backing') return outfit.merchantProductSku;
      });
      setLoading(true);
      setAfterApplyFilter(appliedFilters);
      setAfterApplyFilterNeu(appliedFilters);
      // updateCategoryWiseFilters(appliedFilters);
      // setAppliedFilters(appliedFilters)
      setdeselectFilter(appliedFilters);

      if (newCat !== false) {
        setCurrentCategory(newCat);
        // fetchData(variantList, newCat, appliedFilters);
      } else {
        // fetchData(variantList, currentCategory, appliedFilters);
      }
      // add setproadded after facing filter issue when some one come on builder from shared url
      // setproAdded(true)
      // console.log(1, appliedFilters, preFiltersData, appliedFilters, newCat);
      const urlback = window.location.href;
      const urlbackSet = urlback.split('#')[0];
      window.history.pushState(
        'forward',
        null,
        urlbackSet + '#smartBuilder&blank=open'
      );
      setdataBlankData(false);
      setSelectDataAvailable(false);
    }
  }, [applySelectedFilters]);

  useEffect(() => {
    if (afterClearOutFit === true) {
      setAfterClearOutFit(false);
    }
  }, [afterClearOutFit]);

  useEffect(() => {
    if (afterClearOutFitProductPage === true) {
      const variantList = outfitList.map(outfit => {
        if (outfit.categoryName !== 'Backing') return outfit.merchantProductSku;
      });
      const levelOne = [];
      configData.default_categories.forEach(x => {
        // console.log(x,'xx',configData)
        if (x.display_name !== configData.default_categories[0].display_name)
          levelOne.push(x.cat_name);
      });
      configData.possible_categories.forEach(x => {
        if (x.display_name !== configData.default_categories[0].display_name)
          levelOne.push(x.display_name);
      });
      // console.log(
      //   levelOne[0],
      //   'currentCategory',
      //   configData.default_categories[0].display_name
      // );
      // fetchData(variantList, levelOne[0], []);
      setAfterClearOutFitProductPage(false);
    }
  }, [afterClearOutFitProductPage]);

  useEffect(() => {
    // const newsortedProducts = sortProductList(sortOrder, masterVariantList);
    if (collapsedProductData[0] != undefined) {
      let beforeSort = collapsedProductData[0].categoryData.map(
        e => e.variants
      );
      let afterSortData = [];
      beforeSort.forEach(e => {
        e.forEach(ee => {
          afterSortData.push(ee);
        });
      });

      var clean = afterSortData.filter(
        (arr, index, self) =>
          index ===
          self.findIndex(t => t.merchantProductSku === arr.merchantProductSku)
      );

      // console.log(clean)
      const newsortedProducts = sortProductList(sortOrder, clean);
      // getCollapsedProductData(newsortedProducts, currentCategory, appliedFilters);
      getCollapsedProductDataAfterSorting(
        newsortedProducts,
        currentCategory,
        appliedFilters
      );
    }
  }, [sortOrder]);
  useEffect(() => {
    // console.log(1);
    // fetchDataFirstTime(props, modelId);
    const variantList = outfitList.map(outfit => {
      if (outfit.categoryName !== 'Backing') return outfit.merchantProductSku;
    });
    fetchData(variantList, currentCategory, appliedFilters);
    // console.log(currentCategory, 'variantList');
  }, []);

  return (
    <Popup
      open={isOpen}
      modal
      position="top center"
      closeOnDocumentClick={true}
      closeOnEscape={false}
      lockScroll={true}
      contentStyle={popupStyles}
      overlayStyle={overlayStyle}
      onClose={() => setIsOpen(false)}
    >
      {close => (
        <>
          {Loader ? (
            <Spinner />
          ) : (
            <div className="dcs-modal">
              <div id="confirm">
                <div className="message" id="message">
                  <p>Are you sure you'd like to exit the builder?</p>
                  <div className="buttonsetpop">
                    <button
                      className="yes"
                      onClick={() => {
                        window.history.pushState(
                          'forward',
                          null,
                          window.location.href
                        );
                        const messElement = document.getElementById('confirm');
                        messElement.classList.remove('active');
                        close();
                        setIsOpen(false);
                      }}
                    >
                      Exit
                    </button>
                    <button
                      className="no"
                      onClick={() => {
                        const messElement = document.getElementById('confirm');
                        messElement.classList.remove('active');
                      }}
                    >
                      No, Thanks
                    </button>
                  </div>
                </div>
              </div>
              <div className="dc-wrapper">
                <div className="dc-container">
                  <div className="dc-content">
                    {ShowOptions ? (
                      <OptionsPopup
                        backingProducts={backingProducts}
                        optionsDetails={optionsDetails}
                        setOptionsDetails={setOptionsDetails}
                        isOpen={ShowOptions}
                        bundlerType="reelsoptions"
                        addfromOutfit
                        toggleBundler={toggleBundler}
                        parentProduct={outfitList.find(
                          // each => each.categoryName === 'Reels'
                          e =>
                            e.categoryName
                              ? e.categoryName.split('__')[2] === 'Reels' ||
                                e.categoryName.split('__')[2] === 'Fly Reel'
                              : e.categoryCurrent === 'Reels' ||
                                e.categoryCurrent === 'Fly Reel'
                        )}
                        handleAdd={handleAdd}
                        setShowOptions={setShowOptions}
                        OpenPopReels={OpenPopReels}
                      />
                    ) : null}
                    <HeaderComponent
                      configData={configData}
                      currentCategory={currentCategory}
                      setCurrentCategory={setCurrentCategory}
                      outfitList={outfitList}
                      finalArray={finalArray}
                      setFinalArray={setFinalArray}
                      handleCategoryChange={handleCategoryChange}
                      preCatOneSection={preCatOneSection}
                      preCatTwoSection={preCatTwoSection}
                      setcategoryChckForCallData={setcategoryChckForCallData}
                    />
                    {isFull ? (
                      ''
                    ) : (
                      <>
                        {currentFilterData.length != 0 && !isReplaceTrue
                          ? [
                              <div className="left-sidebar" id="left-bar">
                                <h5>
                                  Narrow Choices
                                  <i
                                    className="closelefbar"
                                    onClick={() => {
                                      var x = document.getElementById(
                                        'left-bar'
                                      );
                                      // console.log(x);
                                      if (x.style.display === 'none') {
                                        x.style.display = 'block';
                                        x.style.transition =
                                          'all 2s ease-in-out';
                                      } else if (x.style.display == '') {
                                        x.style.display = 'block';
                                        x.style.transition =
                                          'all 2s ease-in-out';
                                      } else {
                                        x.style.display = 'none';
                                        x.style.transition =
                                          'all 2s ease-in-out';
                                      }
                                    }}
                                  >
                                    <svg
                                      height="329pt"
                                      viewBox="0 0 329.26933 329"
                                      width="329pt"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0" />
                                    </svg>
                                  </i>
                                </h5>
                                {currentFilterData &&
                                  currentFilterData.map((filterType, index) => {
                                    if (
                                      filterType != undefined &&
                                      !isReplaceTrue
                                    ) {
                                      return (
                                        <Filters
                                          key={filterType.attr}
                                          index={index}
                                          filterType={filterType}
                                          appliedFilters={appliedFilters}
                                          currentCategory={currentCategory}
                                          updateValueToFilters={
                                            updateValueToFilters
                                          }
                                        />
                                      );
                                    }
                                  })}
                              </div>,
                            ]
                          : ''}
                      </>
                    )}
                    {isReplaceTrue ? (
                      <ProductReplace
                        itemToReplace={itemToReplace}
                        currentCategory={currentCategory}
                        props={props}
                        handleRemoveItem={handleRemoveItem}
                      />
                    ) : (
                      <ProductList
                        props={props}
                        Loading={Loading}
                        setLoading={setLoading}
                        setLoader={setLoader}
                        productData={collapsedProductData}
                        currentCategory={currentCategory}
                        setCurrentCategory={setCurrentCategory}
                        configData={configData}
                        outfitList={outfitList}
                        setOutfitList={setOutfitList}
                        finalArray={finalArray}
                        setFinalArray={setFinalArray}
                        currentsorting={sortOrder}
                        handleChangeSortOrder={handleChangeSortOrder}
                        appliedFilters={appliedFilters}
                        setAppliedFilters={setAppliedFilters}
                        setAfterApplyFilter={setAfterApplyFilter}
                        afterApplyFilterNeu={afterApplyFilterNeu}
                        setAfterApplyFilterNeu={setAfterApplyFilterNeu}
                        masterVariantList={masterVariantList}
                        setShowOptions={setShowOptions}
                        setOptionsDetails={setOptionsDetails}
                        defaultSelection={defaultSelection}
                        setApplySelectedFilters={setApplySelectedFilters}
                        applySelectedFilters={applySelectedFilters}
                        categoryWiseFilters={categoryWiseFilters}
                        updateCategoryWiseFilters={updateCategoryWiseFilters}
                        afterApplyFilter={afterApplyFilter}
                        isFull={isFull}
                        SetIsFull={SetIsFull}
                        filtersAppliedone={filtersAppliedone}
                        setFiltersAppliedone={setFiltersAppliedone}
                        filtersAppliedoneTrue={filtersAppliedoneTrue}
                        setFiltersAppliedoneTrue={setFiltersAppliedoneTrue}
                        setInputData={setInputData}
                        setproAdded={setproAdded}
                        categoyrListPreSets={categoyrListPreSets}
                        optionalListPreSets={optionalListPreSets}
                        fetchData={fetchData}
                        fetchDataAfteraddprotoCart={fetchDataAfteraddprotoCart}
                        setCollapsedProductData={setCollapsedProductData}
                        stopRunShareFun={stopRunShareFun}
                        setStopRunShareFun={setStopRunShareFun}
                      />
                    )}
                  </div>
                </div>
                <div className="outfit-content">
                  <button
                    className="close dc-close"
                    onClick={() => {
                      const messElement = document.getElementById('confirm');
                      messElement.classList.add('active');
                      let UrlBack = window.location.href.split('#')[0];
                      window.history.pushState('forward', null, UrlBack);
                    }}
                  >
                    &times;
                  </button>

                  <OutFitComponent
                    configData={configData}
                    outfitList={outfitList}
                    setOutfitList={setOutfitList}
                    setLoading={setLoading}
                    currentCategory={currentCategory}
                    setCurrentCategory={setCurrentCategory}
                    setCategoryWiseFilters={setCategoryWiseFilters}
                    finalArray={finalArray}
                    setFinalArray={setFinalArray}
                    setIsOpen={setIsOpen}
                    handleRemoveItem={handleRemoveItem}
                    optionsDetails={optionsDetails}
                    dcConfigDetails={dcConfigDetails}
                    appliedFilters={appliedFilters}
                    categoryWiseFilters={categoryWiseFilters}
                    handleCategoryChange={handleCategoryChange}
                    checkprefiltered={checkprefiltered}
                    applyfiltered={applyfiltered}
                    categoyrListPreSets={categoyrListPreSets}
                    optionalListPreSets={optionalListPreSets}
                    setAppliedFilters={setAppliedFilters}
                    setAfterApplyFilter={setAfterApplyFilter}
                    afterApplyFilterNeu={afterApplyFilterNeu}
                    setAfterApplyFilterNeu={setAfterApplyFilterNeu}
                    setApplySelectedFilters={setApplySelectedFilters}
                    currentOutfit={currentOutfit}
                    SetIsFull={SetIsFull}
                    noSelectedData={noSelectedData}
                    setnoSelectedData={setnoSelectedData}
                    inputData={inputData}
                    setInputData={setInputData}
                    afterClearOutFit={afterClearOutFit}
                    setAfterClearOutFit={setAfterClearOutFit}
                    afterClearOutFitProductPage={afterClearOutFitProductPage}
                    setAfterClearOutFitProductPage={
                      setAfterClearOutFitProductPage
                    }
                    setShowOptions={setShowOptions}
                    OpenPopReels={OpenPopReels}
                    setOpenPopReels={setOpenPopReels}
                    fetchData={fetchData}
                    afterClearBuilderCallAgain={afterClearBuilderCallAgain}
                    baseItemProductSku={props.productSku}
                    stopRunShareFun={stopRunShareFun}
                    setStopRunShareFun={setStopRunShareFun}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </Popup>
  );
};

export default DCContainer;
